import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  Self,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatSort, Sort } from '@angular/material/sort';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import {
  CONFIG_VALUES,
  formatCurrency,
  OPERATORS,
  polarization,
  SENSOR_BAND_DATA,
  VALUE_ADDED_DATA_PRODUCTS,
} from 'src/app/services/constants';
import { DataService } from 'src/app/services/data.service';
import { PopupService } from 'src/app/services/popup.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PreviescreenComponent } from '../../previescreen/previescreen.component';
import { Router } from '@angular/router';
import { WarningPopup } from '../../warning-popup/warning-popup';
import { SensorpreviewComponent } from '../../sensorpreview/sensorpreview.component';
import { AgreeComponent } from '../../agree/agree.component';
import { AdvanceSettingsComponent } from '../../advance-settings/advance-settings.component';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { VoyageCreditInfoComponent } from '../../voyage-credit-info/voyage-credit-info.component';
import { VesselFinderCreditInfoComponent } from '../../vesselfinder-credit-info/vesselfinder-credit-info.component';
import { OperatorPopupComponent } from '../../../taskcost/operator-popup/operator-popup.component';
import { lastValueFrom } from 'rxjs';
import { applySatelliteVuResolutionConstraints, getSatelliteVuBandsTooltip } from '../../utils/satellitevu-resolution';
import { applyUmbraModeConstraints, getUmbraScenePrice, isUmbraScanMode } from '../../utils/umbra-scan';
import {
  cancellationPolicySentence,
  formatCancellationPolicyEntries,
  OperatorStrategyFactory,
} from 'src/app/services/operators';
import { SharedDataService } from '../../../shared/shared-data-service';

interface CustomWMSOptions extends L.WMSOptions {
  env?: string;
  styles?: string;
}

@Component({
  selector: 'app-taskcost-sensor-preview',
  templateUrl: './taskcost-sensor-preview.component.html',
  styleUrls: ['./taskcost-sensor-preview.component.scss'],
})
export class TaskcostSensorPreviewComponent implements OnInit, OnChanges {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('mySelects') mySelects: MatSelect;
  @Input() showCloseButton = true;

  @Input() showHeader = true;
  @Input() enableSelection = false;
  @Input() preSelectedSensorIds: string[] = [];
  @Input() initialSensorType: string | null = null;
  selectedSARBandType: any;
  selectedInSARBandType: any;
  sensors: any;
  SensorsTypes: any;
  totalAmount: number;
  currency: any;
  currencySign: any;
  currentUser: any;
  SENSORS: any[];
  AVAILABLESENSORS: any = [];
  FILTEREDSENSORS: any[];
  selectedSensorTypes: string;
  dataSource: any;
  displayedColumns: string[] = [
    'operator',
    'location',
    'band',
    'preview',
    'sattarcking',
    'mode',
    'resolution',
    'swath',
    'area_calculated',
    'cloudcovers',
    'ONA',
    'unitcost',
    'holdback',
    'advance',
    'cost',
    'opportunity',
    'footprint',
    'clientInfo',
    'eula',
  ];
  selectedSensors: any[] = [];
  selectedLatency: any = [];
  tooltip: any[];
  totalAOI: any;
  isAllSensors = false;
  isNightSensor = false;
  isDailySubdaily = false;
  isOpportunitySensors:boolean = false;
  isObfuscatedSensors:boolean = false;
  activeCapabilityToggle: string | null = null;
  isAllSensorTypesChecked: boolean = false;
  isBulkSensorTypesLoading: boolean = false;
  enable: boolean = false;
  modeName: string;
  cloudFactor = 1;
  ONAFactor = 1;
  holdBack = 1;
  userDetails: any;
  tooltipValue: any;
  readonly geosatTaskingWindowCostTooltip = 'The cost shown for each tier is an add-on cost to the tasking cost calculated using the unit cost applied to the selected area';
  resolutionTooltip: boolean = false;
  tooltipDisabled: boolean = true;
  detailsText: any = '';
  private sensorSortBaseline: any[] = [];
  satCapeEnable: boolean;
  capellaEnable: boolean;
  selectedItems: any[] = [];
  selectedLatencyKey: any = [];
  demoView: boolean = false;
  OPERATOR: any;
  showColumn: boolean = true;
  selectedSensorList: any[] = [];
  nameONA: string = 'ONA/Look/Grazing Angle';
  spot: boolean = false;
  strip: boolean = false;
  uniqueNamesData: any = [];
  observationSensorTypeOption: any = [];
  tnqSensorDisabled: boolean = true;
  selectedTnqSensorType: any;
  getSensorObj: any = [];
  darkTheme: boolean = false;
  tooltipImagePath: string;
  isDailySubdailySensorTooltip: string;
  qualitySticker: string;
  orbitImage: string;
  maskImage: string;
  cpcAndAllocated: boolean = false;
  operatorsEula: any;
  showLooks: boolean = false;
  showSwath: boolean = false;
  totalTaskNumber = 0;
  dem_calculation = true;
  lband: boolean = false;
  lbandOnly: boolean = false;
  singleCircle: any;
  initialSelection: any[] = [];
  rfSignals: boolean = false;
  isDurationChanging: boolean = false;
  columnResolution: string = 'Resolution';
  tripleHeader: boolean = false;
  aisOnly: boolean = true;
  resolutionColumnTooltip: string = 'Spatial or pixel resolution, depending on ground sample distance (GSD) or re-sampled';
  selectedItemsByGroup: { [key: string]: any[] } = {};
  actionProviders = ['DEM', 'DSM', 'DTM'];
  enable_indices_calculation = false;
  @ViewChild('vadpselect') vadpSelect!: MatSelect;
  polarization: any;
  onaTooltip: string;
  superResolutions: any = [];
  enable_sr_calculation = true;
  private originalClose: (() => void) | null = null; // Correctly typed function
  bandInfoTooltip: any;
  selectedOperator: any;
  target: any;
  advanceSettingsImage: string;
  taskTierPref: string = 'high';
  spotMode: string = 'SPOT';
  stripMode: string = 'STRIP';
  feedInfoTooltip: any;
  defaultCapellaPol = 'HH';
  marginValueExist: boolean = false;
  @Output() closeRequested = new EventEmitter<void>();
  @Output() backClicked = new EventEmitter<void>();
  @Output() sensorsSelected = new EventEmitter<
    { id: string; sensorType: string; sensorName: string }[]
  >();
  selection = new SelectionModel<any>(true, []);
  private suppressSelectionEmit = false;
  private hasAppliedPreselection = false;
  constructor(
    private readonly elementRef: ElementRef,
    private authService: AuthService,
    private userService: UserService,
    private apiService: ApiService,
    @Optional() private dialog: MatDialog,
    private popupService: PopupService,
    private localStorageService: DataService,
    @Optional() public dialogRef: MatDialogRef<any>,
    private router: Router,
    private cd:ChangeDetectorRef,
    private operatorStrategyFactory: OperatorStrategyFactory,
    private sharedData: SharedDataService
  ) {
    this.OPERATOR = OPERATORS;
    this.polarization = polarization;
    this.currentUser = this.authService.userValue;
    if (this.currentUser?.id) {
      this.userDetails = this.currentUser;
      
      this.cpcAndAllocated =
        this.userDetails?.cpc && this.userDetails?.allocated;
    }

    this.localStorageService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

      this.tooltipImagePath = this.darkTheme
        ? '../../../assets/images/union-dark.svg'
        : '../../../assets/images/union.svg';
      this.isDailySubdailySensorTooltip = this.darkTheme
        ? '../../../assets/images/eye_tracking_dark.png'
        : '../../../assets/images/eye_tracking.png';
      this.orbitImage = this.darkTheme
        ? '../../../assets/images/orbit-dark.png'
        : '../../../assets/images/orbit.png';
      this.maskImage = this.darkTheme
        ? '../../../assets/images/mask-dark.png'
        : '../../../assets/images/mask.png';
      this.advanceSettingsImage = this.darkTheme
        ? '../../../assets/images/advance-dark.png'
        : '../../../assets/images/advance.png';
      this.qualitySticker = this.darkTheme
        ? '../../../assets/images/qualitySticker.svg'
        : '../../../assets/images/qualitySticker.svg';
    });
  }

  ngOndestroy() {
    this.elementRef.nativeElement.remove();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['enableSelection'] || changes['preSelectedSensorIds']) {
      // Allow edit-mode preselection to be applied again when inputs change.
      this.hasAppliedPreselection = false;
    }

    // Add 'select' column when enableSelection becomes true
    if (changes['enableSelection'] && this.enableSelection) {
      this.ensureSelectColumn();
    }

    // Handle preSelectedSensorIds changes (for edit mode)
    if (
      changes['preSelectedSensorIds'] &&
      !changes['preSelectedSensorIds'].firstChange
    ) {
      if (this.enableSelection && this.preSelectedSensorIds?.length > 0) {
        // First, update sensor type checkboxes based on preSelectedSensorIds
        if (this.SENSORS && this.SensorsTypes) {
          const preselectedSensors = this.SENSORS.filter((sensor) =>
            this.preSelectedSensorIds.includes(sensor.sensorId),
          );
          const requiredSensorTypes = Array.from(
            new Set(preselectedSensors.map((sensor) => sensor.sensortype)),
          );

          // Update sensor type selections
          let firstSelectedIdx = -1;
          this.SensorsTypes.forEach((type, index) => {
            const shouldBeSelected = requiredSensorTypes.includes(type.value);
            if (shouldBeSelected && firstSelectedIdx === -1) {
              firstSelectedIdx = index;
            }
            this.SensorsTypes[index].selected = shouldBeSelected;
          });
          this.syncAllSensorTypesCheckbox();

          // If sensor types were changed, update the data
          if (firstSelectedIdx > -1) {
            this.updateAllComplete(
              this.SensorsTypes[firstSelectedIdx],
              firstSelectedIdx,
              1
            );
          }
        }

        // Then apply sensor selection in the table (if data is ready)
        if (this.dataSource?.data) {
          this.applyPreselection();
        }
      }
    }
  }

  async ngOnInit() {
    this.currency = environment.payCurrency;
    this.currencySign = environment.payCurrencySign;
    this.observationSensorTypeOption = this.apiService.observationSensorType;
    this.totalAmount = 0;
    if (environment.demoView === 'true') {
      this.demoView = true;
    } else {
      this.demoView = false;
    }
    await this.loadSensors();
    this.cd.detectChanges();
  }

  async loadSensors() {
    let userSubs = this.userDetails?.subscriptionType || 'standard';
    let response = await lastValueFrom(this.apiService.intentOption());
      let intent: any;
      const internalUseItem = response.find(
      (item: any) => item.intent_key === 'internalUse',
      );
      if (internalUseItem) intent = internalUseItem?._id;
      else intent = response[0]?._id;

    const result: any = await lastValueFrom(
      this.userService.getSensors(
        userSubs,
        this.currentUser?.id,
        intent,
        this.getSensorObj,
      ),
    );
          this.rfSignals = false;
          if (result) {
            if (result[0].operators) {
              const allocatedSensorTypes = Array.from(
          new Set(result[0].operators.map((item) => item.sensortype)),
              );
          //     this.previewSensorsTypes = this.apiService.SENSORSTYPE.filter((sensor) =>
          // allocatedSensorTypes.includes(sensor.value),
          //     );
                  this.SensorsTypes = this.apiService.SENSORSTYPE.filter(sensor => allocatedSensorTypes.includes(sensor.value)).map(sensor => ({ ...sensor }));
              if (this.currentUser.allocated) {
                this.SensorsTypes = this.SensorsTypes.filter(
            (sensor) => sensor.name !== 'AIS',
          );
        }
        this.SENSORS = result[0].operators;

        // Determine which sensor types to preselect based on preSelectedSensorIds
        let sensorTypesToSelect: string[] = [];
        if (this.enableSelection && this.preSelectedSensorIds?.length > 0) {
          const preselectedSensors = this.SENSORS.filter((sensor) =>
            this.preSelectedSensorIds.includes(sensor.sensorId),
          );
          sensorTypesToSelect = Array.from(
            new Set(preselectedSensors.map((sensor) => sensor.sensortype)),
          );
        }

        let selectedIndx = -1;

        if (this.initialSensorType) {
          const normalizedInitialType = this.initialSensorType.trim();
          this.SensorsTypes.forEach((type, index) => {
            const matchesInitialType =
              type.value?.toLowerCase() === normalizedInitialType.toLowerCase();

            if (matchesInitialType) {
              this.SensorsTypes[index].selected = true;
              if (selectedIndx === -1) {
                selectedIndx = index;
              }
            } else {
              this.SensorsTypes[index].selected = false;
            }
          });
        }

        this.SensorsTypes.forEach((type, index) => {
          if (this.initialSensorType && selectedIndx !== -1) {
            return;
          }

          // Check if should be selected from preSelectedSensorIds or selectedSensorTypes
          if (sensorTypesToSelect.length > 0) {
            if (sensorTypesToSelect.includes(type.value)) {
              if (selectedIndx === -1) selectedIndx = index;
              this.SensorsTypes[index].selected = true;
            } else {
              this.SensorsTypes[index].selected = false;
            }
          } else if (this.selectedSensorTypes) {
            if (this.selectedSensorTypes.includes(type.value)) {
              selectedIndx = index;
              this.SensorsTypes[index].selected = true;
            }
          } else {
            this.SensorsTypes[index].selected = false;
          }
        });
        this.syncAllSensorTypesCheckbox();
        this.dataSource = undefined;
        this.FILTEREDSENSORS = [];
        if (this.SENSORS) {
          this.SENSORS.forEach((sensor) => {
            this.FILTEREDSENSORS.push(sensor);
          });
        }
        this.dataSource = undefined;
        this.AVAILABLESENSORS = [];
        this.selectedSensors = [];

        this.selectedSARBandType = 'All';
        this.selectedInSARBandType = 'All';

        // Call updateAllComplete for the first selected sensor type
        // This will trigger the proper column setup and data initialization
        if (selectedIndx > -1) {
          this.updateAllComplete(this.SensorsTypes[selectedIndx], selectedIndx, 1);
        }

        if (this.FILTEREDSENSORS.length > 0) this.initializeData();
      }
    }
  }

  async initializeData(sort: boolean = false) {
    let i = 0,
      areacalc = 0,
      minArea = 0;
    this.tooltip = [];
    const targetArea = 0;
    let selectedTaskingPrice: any, selectedHistoricalPrice: any;
    this.AVAILABLESENSORS = [];

    this.FILTEREDSENSORS.forEach(async (sensor: any, i) => {
      const target = targetArea === 0 ? 'POI' : 'AOI';

      if (sensor?.key === OPERATORS.SATELLOGIC) {
        let priceArray = sensor?.pricing;
        if (priceArray) {
          // Filter out "rush" from latency array if target is "AOI"
          if (target === 'AOI' && !this.currentUser.allocated) {
            sensor.latency = sensor.latency.filter(
              (item) => item.key !== 'rush',
            );
          }
        }
      }

      this.sortLatencyByTierPref(sensor);
      this.selectedLatency[i] = sensor?.latency[0]?.name;
      this.selectedLatencyKey[i] = sensor?.latency[0];
      if (sensor.name) {
        this.totalAOI = sensor.minareaspot;
        minArea = sensor.minareaspot;

        if (sensor.areacalc) {
          areacalc = sensor.areacalc;
        } else {
          areacalc = 0;
        }
        const cloudC: any = [];
        for (var key in sensor.cloudcover) {
          cloudC.push({ key, value: sensor.cloudcover[key] });
        }

        let cloudcovers: any,
          selectedModes: any = [],
          modeSelected: any = [];
        let SZA: any,
          AC: any,
          selectedHoldBackOption: any,
          selectedCC: any,
          cloudcover: any;
        let defaultAzimuthAngleMax: any,
          defaultAzimuthAngleMin: any,
          defaultGrazingAngleMax: any,
          defaultGrazingAngleMin: any,
          defaultPolarization: any;

        if (sensor?.cloudcover) {
          cloudcovers = cloudC;
          cloudcover = cloudC[0].key;
          selectedCC = cloudC[0].key;
        }

        let cloudcovernew: any, defaultMinTooltip: any, defaultMinArea: any;
        if (sensor?.cloudcover) cloudcovernew = sensor.cloudcover;
        let collectmodes: any;
        if (sensor.collectmodes) collectmodes = sensor.collectmodes;
        if (sensor?.resolution || sensor.rf_services) {
          if (sensor?.key === OPERATORS.USL && sensor?.name === 'BRO') {
            var selectedResolution = sensor?.rf_services[0];
          } else {
            var selectedResolution = sensor?.resolution[0];
          }

          if (
            (sensor?.key === OPERATORS.AT21 ||
              sensor?.key === OPERATORS.GHG ||
              sensor?.key === OPERATORS.ECURS ||
              sensor?.key === OPERATORS.ECURS_L) &&
            sensor.resolution?.length > 1
          ) {
            sensor.resolution.forEach((res, index) => {
              res.disable = index !== 0; // Set disable = true for all except the first element
            });
          }

          if (
            sensor?.key === OPERATORS.SYNSPECTIVE &&
            sensor.resolution?.length > 1 &&
            sensor?.sensor === 'SAR'
          ) {
            sensor.resolution[0].disable = true;
            selectedResolution = sensor.resolution[1];
            sensor.resolution[1].disable = false;
          }
        }
        if (sensor?.collection_mode?.length > 0) {
          selectedModes.push(sensor?.collection_mode[0]);
          modeSelected.push(sensor?.collection_mode[0]);
          if (
            (sensor?.key === OPERATORS.BLACKSKY || sensor?.key === OPERATORS.OSK)  &&
            selectedModes[0].sceneSize
          ) {
            minArea = selectedModes[0].sceneSize;
          }
          if (sensor?.key === OPERATORS.STE_TELEOS) {
            this.getCustomTooltip(sensor?.collection_mode);
            defaultMinArea = sensor?.collection_mode[0]?.value;
            defaultMinTooltip = sensor?.collection_mode[0]?.minTooltip;
          } else {
            defaultMinArea = sensor?.collection_mode[0]?.value;
            defaultMinTooltip = sensor?.collection_mode[0]?.minTooltip;
          }
        }

        cloudcover = '';
        selectedCC = '';

        if (sensor?.ONA?.length > 0 || sensor?.onaWithResolution?.length > 0) {
          //  var selectedONAOption = sensor?.onaWithResolution ?  sensor?.onaWithResolution[0]:sensor?.ONA[0];
          let filteredSensors = sensor?.onaWithResolution
            ? sensor?.onaWithResolution?.filter(
                (item: any) => item.default === true,
              )
            : sensor?.ONA;

          var selectedONAOption = sensor?.onaWithResolution
            ? filteredSensors[0]
            : sensor?.ONA[0];
          var uniqueOnaArray = sensor?.onaWithResolution
            ? this.getUniqueOnaArray(sensor?.onaWithResolution)
            : sensor.ONA;

          if (
            selectedONAOption &&
            !selectedONAOption?.key &&
            sensor?.onaWithResolution
          ) {
            selectedONAOption.key = selectedONAOption?.ona;
            sensor.selectedONA = selectedONAOption.ona
              ? selectedONAOption?.ona
              : selectedONAOption?.key;
            selectedONAOption.value = selectedONAOption.onaUplift
              ? selectedONAOption?.onaUplift
              : selectedONAOption?.value;
            sensor.selectedONAOption = selectedONAOption;
            sensor.ONAFactor = selectedONAOption.value;

            if (sensor.resolution.length < 2 && sensor?.onaWithResolution)
              if (selectedONAOption?.resolution) {
                let newResoution: any = {
                  key: '0',
                  value: selectedONAOption.resolution,
                  originalResolution: selectedONAOption.forResolution,
                };
                if (sensor?.key !== OPERATORS.GEOSAT) {
                  newResoution.bands =
                    selectedONAOption?.bands ?? sensor.resolution[0]?.bands;
                }
                if (selectedONAOption?.mode_value) {
                  newResoution.mode_value = selectedONAOption?.mode_value;
                }
                sensor.resolution = [newResoution];
                sensor.selectedResolution = newResoution;
              }
            if (sensor.resolution.length > 1 && sensor?.onaWithResolution) {
              const resolutionArray = this.createResolutionArray(
                sensor?.onaWithResolution,
                sensor.selectedONA,
                sensor.resolution,
                sensor.key,
              );
              sensor.resolution = resolutionArray;
              selectedResolution = resolutionArray[0];
            }
          }
        }

        if (isUmbraScanMode(sensor, selectedModes) && Array.isArray(sensor?.resolution)) {
          const supportedResolutions = selectedModes[0]?.resolution;

          if (Array.isArray(supportedResolutions) && supportedResolutions.length > 0) {
            let selectedUmbraResolution: any = null;

            for (const item of sensor.resolution) {
              const isAllowed = supportedResolutions.includes(item.value);
              item.disabled = !isAllowed;

              if (!selectedUmbraResolution && isAllowed) {
                selectedUmbraResolution = item;
              }
            }

            if (selectedUmbraResolution) {
              selectedResolution = selectedUmbraResolution;
            }
          }
        }

        if (sensor?.key === OPERATORS.CAPELLA) {
          selectedResolution = this.applyCapellaResolutionConstraints(
            sensor,
            selectedModes[0],
          ) ?? selectedResolution;
        }

        if (sensor?.SZA?.length > 0) {
          SZA = sensor?.SZA[0];
        }
        if (sensor?.AC?.length > 0) {
          AC = sensor?.AC[0];
        }

        if (sensor?.holdback?.length > 0) {
          selectedHoldBackOption = sensor?.holdback[0];
        }

        if (sensor?.key === OPERATORS.UMBRA) {
          defaultAzimuthAngleMax = sensor?.targetAzimuthAngleMax;
          defaultAzimuthAngleMin = sensor?.targetAzimuthAngleMin;
          defaultGrazingAngleMax = sensor?.targetGrazingAngleMax;
          defaultGrazingAngleMin = sensor?.targetGrazingAngleMin;
          defaultPolarization = sensor?.sarPolarization[0].value;
        }

        if (sensor?.key === OPERATORS.LBAND) {
          for (let i = 0; i < sensor.signal_of_interest.length; i++) {
            sensor.signal_of_interest[i].isAudio = false;
          }
        }

        if (sensor?.key === OPERATORS.WYVERN) {
          sensor.numberOfBands = sensor.band_options[0].no_of_bands;
          sensor.tooltip = sensor.band_options[0].tooltip;
        }

        if (sensor?.key === OPERATORS.ESPER || sensor?.key === OPERATORS.OSK) {
          sensor.numberOfBands = sensor.band_options[0].no_of_bands;
        }

        if (!sensor.numberOfBands && sensor?.band_options?.length > 0) {
          sensor.numberOfBands = sensor.band_options[0].no_of_bands;
        }

        const deliveytime_stand = new Date().setDate(
          new Date().getDate() + sensor.latency_standard,
        );
        const defaultLatency = [],
          latencySTE: any = [],
          latency: any = [];
        let unitcost = 0;

        if (sensor?.key === OPERATORS.CLYDE) {
          let totalAOIInMillion = targetArea / 1000000;

          let selectedKey = Object.keys(sensor?.pricing).find(
            (key) => totalAOIInMillion <= Number(key),
          );
          if (!selectedKey) {
            selectedKey = Object.keys(sensor.pricing).sort(
              (a: any, b: any) => b - a,
            )[0];
          }

          let selectedhistoricalKey = Object.keys(
            sensor?.historicalPricing,
          ).find((key) => totalAOIInMillion <= Number(key));
          if (!selectedhistoricalKey) {
            selectedhistoricalKey = Object.keys(sensor.historicalPricing).sort(
              (a: any, b: any) => b - a,
            )[0];
          }

          selectedTaskingPrice = {
            data: {
              selectedKey,
              price: sensor.pricing[selectedKey],
            },
          };

          selectedHistoricalPrice = {
            data: {
              selectedhistoricalKey,
              price: sensor.historicalPricing[selectedhistoricalKey],
            },
          };
        }

        for (let j = 0; j < sensor.latency.length; j++) {
          let selected = false;
          if (j === 0) selected = true;

          var calCost = sensor.latency[j]?.unitcost;
          var unitCost = sensor.latency[j]?.unitcost;
          if (sensor?.key === OPERATORS.UMBRA) {
            if (sensor.resolution) {
              var calCost = sensor.resolution[0]?.cost;
              var unitCost = sensor.resolution[0]?.cost;
            }
          }

          if (sensor?.key === OPERATORS.CLYDE) {
            var calCost = selectedTaskingPrice.data.price;
            var unitCost = selectedTaskingPrice.data.price;
          }

          if (
            sensor?.key === OPERATORS.AXELSPACE &&
            this.currentUser.id != CONFIG_VALUES.AxelCustomerId
          ) {
            let unitPrice: any = this.getAxelPrice(targetArea, sensor.pricing);
            var calCost = unitPrice;
            var unitCost = unitPrice;
          }

          // `??`, not truthiness: an operator whose response time is a phrase
          // rather than a duration states mode: "" and gets no comparator in
          // front of it. Voyage Radar's "Immediate" is the first — under a
          // truthiness check its empty mode read as absent and the column
          // rendered "<= Immediate".
          var mode: any = sensor.latency[j]?.mode ?? '<=';
          if (this.currentUser?.channelPrice) {
            var calCost = sensor.channelPrice[sensor.latency[j]]?.unitcost;
            var unitCost = sensor.channelPrice[sensor.latency[j]]?.unitcost;
          }

          latency.push({
            name: sensor.latency[j]?.name,
            unitcost: unitCost,
            cost: calCost,
            latency: sensor.latency[j]?.latency,
            selected: selected,
            mode: mode,
            sensor: sensor.name,
            taskingwindow: sensor.latency[j]?.taskingwindow,
            collectionWindow: sensor.latency[j]?.collectionWindow,
            key: sensor.latency[j]?.key,
            // Preserve upliftCost for operators like GEOSAT that use mode-based pricing
            upliftCost: sensor.latency[j]?.upliftCost,
            reactionUpliftCost: sensor.latency[j]?.reactionUpliftCost,
            responseUpliftCost: sensor.latency[j]?.responseUpliftCost,
            taskingWindowCost: (sensor.latency[j]?.reactionUpliftCost ?? 0) + (sensor.latency[j]?.responseUpliftCost ?? 0),
          });
        }

        let STElatency: any = [];
        if (
          sensor?.key === OPERATORS.STE ||
          sensor?.key === OPERATORS.STE_TELEOS
        ) {
          latencySTE.push(latency);
          STElatency = JSON.parse(JSON.stringify(latencySTE));
        }

        if (sensor?.key === OPERATORS.OSK) {
           let area = target === 'POI' ? 'poi' : 'aoi';

          if (sensor.pricing_unit) {
            sensor.pricingUnit = sensor.pricing_unit[area];
          }
        }

        let taskcost;
        // Initialize cost from first collection mode for Consteller operator
        if (sensor?.key === OPERATORS.CONSTELLR && selectedModes?.length > 0 && selectedModes[0]?.cost) {
          taskcost = selectedModes[0].cost;
        }
        const existId = this.AVAILABLESENSORS.filter(function (el) {
          return sensor?.sensorId === el?.sensorId;
        });
        const satIds = sensor?.satIds
          ? sensor?.satIds.map((obj) => obj.id)
          : [];
        const initialSensorTooltip = this.getInitialSensorTooltip(
          sensor,
          selectedModes,
        );

        if (existId.length === 0) {
          if (
            this.selectedSensorTypes &&
            sensor?.name != 'TripleSat' &&
            sensor?.name != 'Daily Vision 75' &&
            sensor?.name != 'Daily Vision Wide' &&
            sensor?.name != 'Jilin'
          ) {
            if (sensor.enabled) {
              const tooltip = sensor;
              this.AVAILABLESENSORS.push({
                name: sensor.name,
                ...(sensor.rf_services
                  ? { rf_services: sensor.rf_services }
                  : { resolution: sensor.resolution }),
                unit: sensor.key == OPERATORS.OSK ? sensor.pricing_unit.poi : sensor.costunit,
                pricingUnit: sensor.pricingUnit
                  ? sensor.pricingUnit
                  : sensor.costunit,
                type: sensor?.type,
                unitcost: unitcost,
                sensor: sensor.sensor,
                sensortype: sensor.sensortype,
                minarea: minArea,
                areacalc: areacalc,
                area_calculated: this.totalAOI,
                tooltip: tooltip,
                cloudcovers: cloudcovers,
                cloudcover: cloudcover,
                cloudnew: cloudcovernew,
                collectmodes: collectmodes,
                defaultLatency: defaultLatency,
                latency: latency,
                selectedCost: taskcost,
                selectedCC: selectedCC,
                selectedLatency: this.selectedLatency[i],
                selectedLatencyKey: this.selectedLatencyKey[i],
                cost: taskcost,
                enabled: sensor.enabled,
                ONA: uniqueOnaArray ? uniqueOnaArray : sensor.ONA,
                holdback: sensor.holdback,
                collection_mode: this.sortedWeatherExCollectionMode(sensor),
                country: sensor.country,
                selectedModes: selectedModes,
                selectedONAOption: selectedONAOption,
                sensorTooltip: initialSensorTooltip,
                sensorDesc: sensor?.sensordesc,
                rushCloudCover: false,
                key: sensor?.key,
                operatorEmail: sensor?.operatorEmail,
                modeType: sensor?.multiplemode || sensor?.key === OPERATORS.WEATHEREX,
                modeSelected: modeSelected,
                satIds: satIds,
                SZA: SZA,
                AC: AC,
                high_cadence: sensor?.high_cadence,
                isObfuscated: sensor?.isObfuscated,
                cadence_value: sensor?.cadence_value,
                selectedResolution: selectedResolution,
                selectedResolutionValue: selectedResolution?.value,
                sarPolarization: sensor?.sarPolarization,
                sarOrbitDirection: sensor?.sarOrbitDirection,
                productAnciallary: sensor?.productAnciallary,
                satelliteName: sensor?.satelliteName,
                collectionCost: sensor?.collection_cost,
                selectedHoldBackOption: selectedHoldBackOption,
                feasibility: sensor?.feasibility,
                tooltipValue: defaultMinTooltip,
                selectedAnciallary: '',
                selectedOrbitDirection: '',
                selectedPolarization: '',
                siteData: sensor?.siteData,
                collectionunit: sensor.key == OPERATORS.OSK ? sensor.pricing_unit.poi : sensor?.collectionunit,
                selectedTnqSensorType: '',
                tnqSensorDisabled: true,
                minimumArea: defaultMinArea,
                captureMode: '',
                STElatency: STElatency,
                defaultPolarization: defaultPolarization,
                defaultAzimuthAngleMax: defaultAzimuthAngleMax,
                defaultAzimuthAngleMin: defaultAzimuthAngleMin,
                defaultGrazingAngleMax: defaultGrazingAngleMax,
                defaultGrazingAngleMin: defaultGrazingAngleMin,
                pricing: sensor?.pricing,
                cancelPolicy: sensor?.cancel_policy,
                onaWithResolution: sensor?.onaWithResolution,
                imageryname: sensor?.imageryname,
                selectedTaskingPrice: selectedTaskingPrice,
                selectedHistoricalPrice: selectedHistoricalPrice,
                sensorId: sensor?.sensorId,
                valAddedArray: sensor.valueAddedOption,
                valueAddedAction: this.formatvalueAddedOption(
                  sensor,
                  selectedModes,
                  selectedResolution,
                ),
                signal_of_interest:
                  sensor?.key === OPERATORS.USL
                    ? selectedModes
                    : this.setSignalOfInterest(sensor?.signal_of_interest),
                collection_duration: sensor?.collection_duration,
                updateFrequency: sensor?.updateFrequency,
                refreshRates: sensor?.refreshRates ?? null,
                selectedRefreshRate: sensor?.refreshRates?.[0] ?? null,
                indicesArray: this.setIndices(sensor, selectedResolution),
                superResolutions: this.setSuperResolutions(sensor),
                no_imagery_country: sensor?.no_imagery_country,
                obfuscateName: sensor?.obfuscateName,
                displayName:
                  this.currentUser.obfuscated && sensor.obfuscateName
                    ? sensor.obfuscateName
                    : sensor.name,
                sarOrbitType: sensor?.sarOrbitType,
                bitDepth: sensor?.bitDepth,
                sensorBands: sensor?.bands,
                bandOptions: sensor?.band_options,
                numberOfBands: sensor?.numberOfBands,
                supportedTarget: this.checkSupportedTarget(sensor),
                informationFeeds: sensor?.informationfeeds,
                /* Voyage Radar prices per credit, and "per credit" means
                   nothing without the catalogue that spends it. Carried raw:
                   normalizeCreditActions / resolveCreditBounds are the only
                   things allowed to interpret these, so this row and the
                   purchase dialog cannot disagree about a price. */
                apiCreditActions: sensor?.apiCreditActions,
                minApiCredits: sensor?.minApiCredits,
                maxApiCredits: sensor?.maxApiCredits,
              });

              this.applySatelliteVuInitConstraints(this.AVAILABLESENSORS.length - 1);
            } else {
              const tooltip = {
                name: sensor.name,
                resolution: sensor.resolution,
                unit: sensor.costunit,
                type: sensor?.type,
                unitcost: sensor.unitcost,
                sensor: sensor.sensor,
                sensortype: sensor.sensortype,
                sensorTooltip: initialSensorTooltip,
                sensorDesc: sensor?.sensordesc,
              };
              this.AVAILABLESENSORS.push({
                name: sensor.name,
                resolution: sensor.resolution,
                sensor: sensor.sensor,
                sensortype: sensor.sensortype,
                tooltip: tooltip,
                enabled: sensor.enabled,
                sensorTooltip: initialSensorTooltip,
                sensorDesc: sensor?.sensordesc,
                selectedModes: selectedModes,
                collection_mode: this.sortedWeatherExCollectionMode(sensor),
                selectedONAOption: selectedONAOption,
                type: sensor?.type,
                satIds: satIds,
                key: sensor?.key,
                operatorEmail: sensor?.operatorEmail,
                modeType: sensor?.multiplemode || sensor?.key === OPERATORS.WEATHEREX,
                selectedLatency: this.selectedLatency[i],
                selectedLatencyKey: this.selectedLatencyKey[i],
                modeSelected: modeSelected,
                SZA: SZA,
                AC: AC,
                high_cadence: sensor?.high_cadence,
                isObfuscated: sensor?.isObfuscated,
                cadence_value: sensor?.cadence_value,
                selectedResolution: selectedResolution,
                sarPolarization: sensor?.sarPolarization,
                selectedResolutionValue: selectedResolution?.value,
                sarOrbitDirection: sensor?.sarOrbitDirection,
                productAnciallary: sensor?.productAnciallary,
                satelliteName: sensor?.satelliteName,
                selectedHoldBackOption: selectedHoldBackOption,
                feasibility: sensor?.feasibility,
                tooltipValue: defaultMinTooltip,
                selectedAnciallary: '',
                selectedOrbitDirection: '',
                selectedPolarization: '',
                siteData: sensor?.siteData,
                collectionunit: sensor?.collectionunit,
                minimumArea: defaultMinArea,
                STElatency: STElatency,
                defaultPolarization: defaultPolarization,
                defaultAzimuthAngleMax: defaultAzimuthAngleMax,
                defaultAzimuthAngleMin: defaultAzimuthAngleMin,
                defaultGrazingAngleMax: defaultGrazingAngleMax,
                defaultGrazingAngleMin: defaultGrazingAngleMin,
                pricing: sensor?.pricing,
                cancelPolicy: sensor?.cancel_policy,
                imageryname: sensor?.imageryname,
                selectedTaskingPrice: selectedTaskingPrice,
                selectedHistoricalPrice: selectedHistoricalPrice,
                sensorId: sensor?.sensorId,
                valAddedArray: sensor.valueAddedOption,
                valueAddedAction: this.formatvalueAddedOption(
                  sensor,
                  selectedModes,
                  selectedResolution,
                ),
                updateFrequency: sensor?.updateFrequency,
                refreshRates: sensor?.refreshRates ?? null,
                selectedRefreshRate: sensor?.refreshRates?.[0] ?? null,
                superResolutions: this.setSuperResolutions(sensor),
                no_imagery_country: sensor?.no_imagery_country,
                obfuscateName: sensor?.obfuscateName,
                displayName:
                  this.currentUser.obfuscated && sensor.obfuscateName
                    ? sensor.obfuscateName
                    : sensor.name,
                sarOrbitType: sensor?.sarOrbitType,
                sensorBands: sensor?.bands,
                bandOptions: sensor?.band_options,
                numberOfBands: sensor?.numberOfBands,
                supportedTarget: this.checkSupportedTarget(sensor),
                informationFeeds: sensor?.informationfeeds,
                /* Voyage Radar prices per credit, and "per credit" means
                   nothing without the catalogue that spends it. Carried raw:
                   normalizeCreditActions / resolveCreditBounds are the only
                   things allowed to interpret these, so this row and the
                   purchase dialog cannot disagree about a price. */
                apiCreditActions: sensor?.apiCreditActions,
                minApiCredits: sensor?.minApiCredits,
                maxApiCredits: sensor?.maxApiCredits,
              });

              this.applySatelliteVuInitConstraints(this.AVAILABLESENSORS.length - 1);
            }
          }
        }

        this.AVAILABLESENSORS.forEach((sensor, index) => {
          if (!sort && sensor?.selectedTaskingTier) return;
          if (Array.isArray(sensor.latency)) {
            sensor.selectedLatency = null;
            sensor.selectedLatencyKey = null;

            const strategy = this.operatorStrategyFactory.getStrategy(sensor?.key);
            strategy?.syncLatencyCosts?.(sensor);

            this.sortLatencyByTierPref(sensor);
            let defaultLatency = sensor.latency[0];
            this.selectedLatency[index] = defaultLatency?.name;
            this.selectedLatencyKey[index] = defaultLatency;
            sensor.selectedLatency = defaultLatency?.name;
            sensor.selectedLatencyKey = defaultLatency;
            sensor.selectedTaskingTierPrefrence = defaultLatency?.key;
            sensor.isUserSelection = false;

            // GEOSAT: compute selectedCost using the chosen default latency.
            if (sensor?.key === OPERATORS.GEOSAT) {
              this.recalculateSelectedCostForRow(index);
            }
          }
        });

        this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
        this.dataSource.sort = this.sort;

        // Preselection is applied once after table build completes.

        for (const [sensorIndex, sensors] of this.AVAILABLESENSORS.entries()) {
          if (sensors?.key === OPERATORS.GHG) {
            sensors.latency = sensors.latency.map((latencyItem) => {
              const matchingMode = sensors.selectedModes[0].cost.find(
                (mode) => mode[latencyItem.key] !== undefined,
              );
              return {
                ...latencyItem,
                cost: matchingMode ? matchingMode[latencyItem.key] : null,
                unitcost: matchingMode ? matchingMode[latencyItem.key] : null,
              };
            });
          }
          if (
            sensors?.key === OPERATORS.CAPELLA ||
            sensors?.key === OPERATORS.GOKTURK ||
            sensor?.key === OPERATORS.BLACKSKY ||
            sensors?.key === OPERATORS.SDS ||
            (sensors?.key === OPERATORS.STE &&
              sensors?.sensor === 'MSI' &&
              sensors.selectedResolution.value.includes('Bundle')) ||
            sensors?.key === OPERATORS.ECURS ||
            sensors?.key === OPERATORS.ECURS_L
          ) {
            let pricingArray = sensors.selectedModes[0]?.pricing;
            if (sensors.latency) {
              for (const latencyItem of sensors.latency) {
                const key = latencyItem.key;
                if (pricingArray && pricingArray.hasOwnProperty(key)) {
                  const newCost = Number(pricingArray[key]);
                  latencyItem.cost = newCost;
                  latencyItem.unitcost = newCost;
                }
              }
            }
          }

          if (sensors?.key === OPERATORS.USL) {
            let priceArray = sensor?.collection_cost;
            let subdailyCount = 1;
            if (priceArray) {
              for (const latencyItem of sensors.latency) {
                for (const pricingItem of priceArray) {
                  if (
                    latencyItem.key === pricingItem.latency &&
                    pricingItem.unit === subdailyCount
                  ) {
                    latencyItem.cost = Number(pricingItem.cost);
                    latencyItem.unitcost = Number(pricingItem.cost);
                    break;
                  }
                }
              }
            }
          }

          if (sensors?.key === OPERATORS.SATELLOGIC) {
            let priceArray = sensor?.pricing;

            if (priceArray) {
              for (const latencyItem of sensors.latency) {
                const key = latencyItem.key;
                if (priceArray[target] !== undefined) {
                  if (priceArray[target][key] !== undefined) {
                    latencyItem.cost = priceArray[target][key];
                    latencyItem.unitcost = priceArray[target][key];
                  }
                }
              }
            }
          }

          if (sensors?.key === OPERATORS.ESPER) {
            let priceArray = sensors?.pricing;
            let bands = 50;

            if (priceArray) {
              for (const latencyItem of sensors.latency) {
                const key = latencyItem.key;
                latencyItem.cost = priceArray[key][bands];
                latencyItem.unitcost = priceArray[key][bands];
              }
            }
          }

          if(sensors?.key === OPERATORS.ORBVIEW){
            let pricingArray = sensors.selectedResolution?.pricing;
            if (sensors.latency) {
              for (const latencyItem of sensors.latency) {
                  const key = this.normalizeOrbviewPricingKey(latencyItem.key);
                  if (pricingArray && Object.prototype.hasOwnProperty.call(pricingArray, key)) {
                  const newCost = Number(pricingArray[key]);
                  latencyItem.cost = newCost;
                  latencyItem.unitcost = newCost;
                }
              }
            }
          }
          this.taskingOption(sensors.selectedLatency, sensorIndex, sensors, 1);
        }
      }
    });

    // After rebuilding the table, remap selection to the new row objects.
    // This preserves user selections across sensor-type toggles and also
    // applies initial edit-mode preselection once data is available.
    this.showSwath = this.AVAILABLESENSORS.some((s) =>
      s.collection_mode?.some((m) => m.swathWidth)
    );
    if (this.enableSelection) {
      this.updateSelectionAfterDataSourceChange();
    }
  }
  getTextLength(captureMode: string, productLevel: string): number {
    const captureModeLength = captureMode ? captureMode.length : 0;
    const productLevelLength = productLevel ? productLevel.length : 0;
    return captureModeLength + (productLevel ? productLevelLength + 3 : 0); // Adding 3 for ' ()'
  }

  createResolutionArray(data, selectedOna, resolution, key) {
    // Initialize the result array and a counter for the auto-increment key
    let result: any = [];
    let counter = 1;

    // Loop through the original data
    data?.forEach((item, index) => {
      // Check if the current item's 'ona' matches the selected 'ona'
      if (item.ona === selectedOna) {
        const matchingResolution = resolution.find(
          (res) =>
            res.value === item.forResolution ||
            res?.originalResolution === item.forResolution,
        );

        // Push the new object with auto-increment key and forResolution value to the result array
        const resolutionOption: any = {
          key: counter,
          value: item.resolution,
          order: item.order,
          originalResolution: item.forResolution,
          onaUplift: item.onaUplift,
          multiplier: matchingResolution?.multiplier,
          combinedResolution: item?.combinedResolution
            ? item?.combinedResolution
            : matchingResolution?.combinedResolution,
        };
        if (key !== OPERATORS.GEOSAT) {
          resolutionOption.bands = item?.bands ?? matchingResolution?.bands;
        }
        result.push(resolutionOption);
        // Increment the counter
        counter++;
      }
    });

    result.sort((a, b) => a.order - b.order);
    if (result?.length > 1 && key !== OPERATORS.AXELSPACE) {
      result[1].disable = true;
    }
    return result;
  }
  getUniqueOnaArray(data: any) {
    // Initialize an empty Set to keep track of unique 'ona' values
    const uniqueOna = new Set();
    // Initialize the result array
    const result: any = [];

    // Loop through the original data
    data.forEach((item) => {
      // If the 'ona' value is not in the Set, add it to the Set and the result array
      if (!uniqueOna.has(item.ona)) {
        uniqueOna.add(item.ona);
        result.push(item);
      }
    });
    result.sort((a, b) => b.default - a.default);
    return result;
  }

  private isSarFamilySensor(sensorType: string): boolean {
    return ['SAR', 'InSAR', 'ScanSAR'].includes(sensorType);
  }

  private isNonImagingSensor(sensorType: string): boolean {
    return ['AIS', 'Weather', 'RF- comms'].includes(sensorType);
  }

  private getImagingResolutionTooltip(sensorTypes: string[]): string {
    const hasSarFamily = sensorTypes.some((sensorType) =>
      this.isSarFamilySensor(sensorType)
    );
    const hasOtherImaging = sensorTypes.some(
      (sensorType) =>
        !this.isNonImagingSensor(sensorType) &&
        !this.isSarFamilySensor(sensorType)
    );

    if (hasSarFamily && hasOtherImaging) {
      return 'Spatial or pixel/Azimuth resolution';
    }

    if (hasSarFamily) {
      return 'Azimuth resolution';
    }

    if (hasOtherImaging) {
      return 'Spatial or pixel resolution, depending on ground sample distance (GSD) or re-sampled';
    }

    return '';
  }

  private updateResolutionColumnMeta(sensorTypes: string[]): void {
    const uniqueSensorTypes = [...new Set(sensorTypes || [])];
    const hasRF = uniqueSensorTypes.includes('RF- comms');
    const hasAIS = uniqueSensorTypes.includes('AIS');
    const hasWeather = uniqueSensorTypes.includes('Weather');
    const imagingResolutionTooltip = this.getImagingResolutionTooltip(uniqueSensorTypes);
    const hasImaging = !!imagingResolutionTooltip;

    const weatherTooltip = 'Grid spatial resolution/ Temporal refresh rate';
    const aisTooltip = 'Signal update frequency';
    const rfTooltip = 'The scope of RF service';

    let heading = 'Resolution';

    if (hasWeather) {
      if (hasImaging) {
        heading = hasRF
          ? 'Resolution/\u00a0Update\u00a0Frequency/\u200BRF\u00a0Service'
          : 'Resolution/\u00a0Update\u00a0Frequency';
      } else if (hasRF) {
        heading = hasAIS
          ? 'RF\u00a0Service/\u200BResolution/\u00a0Update\u00a0Frequency'
          : 'Resolution/\u00a0Update\u00a0Frequency/\u200BRF\u00a0Service';
      } else {
        heading = 'Resolution/\u00a0Update\u00a0Frequency';
      }
    } else if (hasImaging) {
      if (hasRF && hasAIS) {
        heading = 'Resolution/\u200BRF\u00a0Service/\u200BUpdate\u00a0Frequency';
      } else if (hasRF) {
        heading = 'Resolution/\u200BRF\u00a0Service';
      } else if (hasAIS) {
        heading = 'Resolution/\u00a0Update\u00a0Frequency';
      } else {
        heading = 'Resolution';
      }
    } else if (hasRF) {
      heading = hasAIS ? 'RF\u00a0Service/\u200BUpdate\u00a0Frequency' : 'RF\u00a0Service';
    } else if (hasAIS) {
      heading = 'Update\u00a0Frequency';
    }

    const headingParts = heading.split('/');
    const tooltipParts: string[] = [];
    let weatherAdded = false;
    let aisAdded = false;
    let rfAdded = false;
    let imagingAdded = false;

    headingParts.forEach((part) => {
      const cleanPart = part.replace(/[\u200B\u00a0]/g, ' ').trim();
      if (cleanPart === 'RF Service' && hasRF && !rfAdded) {
        tooltipParts.push(rfTooltip);
        rfAdded = true;
        return;
      }

      if (cleanPart === 'Resolution') {
        if (hasImaging && !imagingAdded) {
          tooltipParts.push(imagingResolutionTooltip);
          imagingAdded = true;
          return;
        }

        if (hasWeather && !weatherAdded) {
          tooltipParts.push(weatherTooltip);
          weatherAdded = true;
          return;
        }
      }

      if (cleanPart === 'Update Frequency') {
        if (hasWeather && hasImaging && !weatherAdded) {
          tooltipParts.push(weatherTooltip);
          weatherAdded = true;
        }

        if (hasAIS && !aisAdded) {
          tooltipParts.push(aisTooltip);
          aisAdded = true;
        }
      }
    });

    this.columnResolution = heading;
    this.resolutionColumnTooltip =
      tooltipParts.join('/') ||
      'Spatial or pixel resolution, depending on ground sample distance (GSD) or re-sampled';
    this.tripleHeader = headingParts.length >= 3;
    this.aisOnly = headingParts.length <= 1;
  }

  updateAllComplete(e: any, i: number, type: number = 0) {
    if ((e?.name === 'SAR' || e?.name === 'InSAR') && type == 0) {
      if (e.name === 'SAR') this.selectedSARBandType = null;
      else if (e.name === 'InSAR') this.selectedInSARBandType = null;
    }

    if (e.selected) {
      if ((e?.name === 'SAR' || e?.name === 'InSAR') && type == 0) {
        // Dynamically get unique tooltip values for SAR sensors
        let bands = this.SENSORS
          .filter((sensor) => sensor.sensortype === e.name && sensor.tooltip)
          .map((sensor) => sensor.tooltip)
          .filter((value, index, self) => self.indexOf(value) === index)
          .sort((a, b) => a.localeCompare(b));

        if (bands?.length > 1) {
          bands.push('All');
          const dialog = this.dialog.open(OperatorPopupComponent, {
            minWidth: '50%',
            backdropClass: 'blurred',
            disableClose: true,
            data: {
              bands: bands,
              sensorType: e.name,
              type: 'bandFilter',
            },
          });

          dialog.afterClosed().subscribe((result) => {
            if (result && result !== 'close') {
              if (e.name === 'SAR') this.selectedSARBandType = result;
              else if (e.name === 'InSAR') this.selectedInSARBandType = result;
              if (!this.selectedSensorList.includes(e?.name)) {
                this.selectedSensorList.push(e?.name);
              }
              this.loadSensorDetails(i, e);
              this.syncAllSensorTypesCheckbox();
            } else {
              e.selected = false;
              if (this.SensorsTypes?.[i]) {
                this.SensorsTypes[i].selected = false;
              }
              if (e.name === 'SAR') this.selectedSARBandType = null;
              else if (e.name === 'InSAR') this.selectedInSARBandType = null;
              this.syncAllSensorTypesCheckbox();
              this.clearSelectionForSensorType(e?.value);
              this.loadSensorDetails(i, e);
            }
          });
          return;
        } else {
          if (!this.selectedSensorList.includes(e?.name)) {
            this.selectedSensorList.push(e?.name);
          }
          this.loadSensorDetails(i, e);
          this.syncAllSensorTypesCheckbox();
        }
      } else {
        if (!this.selectedSensorList.includes(e?.name)) {
          this.selectedSensorList.push(e?.name);
        }
        this.loadSensorDetails(i, e);
        this.syncAllSensorTypesCheckbox();
      }
    } else {
      const index = this.selectedSensorList.findIndex(
        (selectedItem) => selectedItem === e.name,
      );
      if (index > -1) {
        this.selectedSensorList.splice(index, 1);
      }
      this.selectedSensors = [];
      if (e?.name === 'SAR') this.selectedSARBandType = null;
      else if (e?.name === 'InSAR') this.selectedInSARBandType = null;
      this.loadSensorDetails(i, e);
      this.syncAllSensorTypesCheckbox();
    }
  }

  loadSensorDetails(i: number, e: any) {
    this.nameONA = 'ONA/Look/Grazing Angle';
    this.showColumn = true;
    this.lbandOnly = false;
    this.columnResolution = 'Resolution';
    this.aisOnly = true;
    this.tripleHeader = false;
    this.resolutionColumnTooltip = 'Spatial or pixel resolution, depending on ground sample distance (GSD) or re-sampled';
    this.onaTooltip =
      'ONA: Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.' +
      '\n' +
      'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
      '\n' +
      'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';

    this.displayedColumns = [
      'operator',
      'location',
      'band',
      'preview',
      'sattarcking',
      'mode',
      'resolution',
      'swath',
      'area_calculated',
      'cloudcovers',
      'ONA',
      'unitcost',
      'holdback',
      'advance',
      'cost',
      'opportunity',
      'footprint',
      'clientInfo',
      'eula',
    ];
    this.ensureSelectColumn();

    // If a sensor type is unchecked, immediately unselect any selected rows
    // belonging to that type so they don't re-appear due to async table rebuilds.
    if (!e?.selected) {
      this.clearSelectionForSensorType(e?.value);
    }

    this.selectedSensorList = (this.SensorsTypes || [])
      .filter((type) => type.selected)
      .map((type) => type.name);
    this.syncAllSensorTypesCheckbox();

    if (
      this.selectedSensorList?.length === 1 &&
      this.selectedSensorList[0] === 'MSI'
    ) {
      this.nameONA = 'ONA';
      this.onaTooltip =
        'Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.';
    }

    if (
      this.selectedSensorList?.length === 1 &&
      (this.selectedSensorList.includes('SAR') ||
        this.selectedSensorList.includes('InSAR'))
    ) {
      this.nameONA = 'Look/Grazing Angle';
      this.onaTooltip =
        'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
        '\n' +
        'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
      this.showColumn = false;

      this.displayedColumns = [
        'operator',
        'location',
        'band',
        'preview',
        'sattarcking',
        'mode',
        'resolution',
        'swath',
        'area_calculated',
        'ONA',
        'unitcost',
        'holdback',
        'advance',
        'cost',
        'opportunity',
        'footprint',
        'clientInfo',
        'eula',
      ];
      this.ensureSelectColumn();
    } else if (
      this.selectedSensorList?.length === 2 &&
      this.selectedSensorList.includes('SAR') &&
      this.selectedSensorList.includes('InSAR')
    ) {
      this.nameONA = 'Look/Grazing Angle';
      this.onaTooltip =
        'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
        '\n' +
        'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
      this.showColumn = false;

      this.displayedColumns = [
        'operator',
        'location',
        'band',
        'preview',
        'sattarcking',
        'mode',
        'resolution',
        'swath',
        'area_calculated',
        'ONA',
        'unitcost',
        'holdback',
        'advance',
        'cost',
        'opportunity',
        'footprint',
        'clientInfo',
        'eula',
      ];
      this.ensureSelectColumn();
    } else if (
      this.selectedSensorList.includes('SAR') ||
      this.selectedSensorList.includes('InSAR')
    ) {
      this.nameONA = 'ONA/Look/Grazing Angle';
      this.onaTooltip =
        'ONA: Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.' +
        '\n' +
        'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
        '\n' +
      'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
      this.showColumn = true;
      this.displayedColumns = [
        'operator',
        'location',
        'band',
        'preview',
        'sattarcking',
        'mode',
        'resolution',
        'swath',
        'area_calculated',
        'cloudcovers',
        'ONA',
        'unitcost',
        'holdback',
        'advance',
        'cost',
        'opportunity',
        'footprint',
        'clientInfo',
        'eula',
      ];
      this.ensureSelectColumn();
    } else {
      this.nameONA = 'ONA';
      this.onaTooltip =
        'Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.';
    }

    if (
      (this.selectedSensorList.includes('Stereo') ||
        this.selectedSensorList.includes('MSI') ||
        this.selectedSensorList.includes('HSI') || this.selectedSensorList.includes('TIR')) &&
      !this.currentUser.allocated &&
      this.hasFeature(VALUE_ADDED_DATA_PRODUCTS)
    ) {
      const modifiedColumns = [...this.displayedColumns];
      const modeIndex = modifiedColumns.indexOf('mode');
      modifiedColumns.splice(modeIndex + 1, 0, 'dem');
      this.displayedColumns = modifiedColumns;
    }

    if (this.selectedSensorList.includes('SAR')) {
      this.showLooks = true;
      const resolutionIndex = this.displayedColumns.indexOf('resolution');
      if (resolutionIndex !== -1) {
        this.displayedColumns.splice(resolutionIndex + 1, 0, 'looks');
      }
    }

    if (this.selectedSensorList.includes('RF- comms')) {
      this.lband = true;
      const resolutionIndex = this.displayedColumns.indexOf('resolution');
      if (resolutionIndex !== -1) {
        this.displayedColumns.splice(
          resolutionIndex + 1,
          0,
          'signalOfInterest',
        );
      }
    }

    this.updateResolutionColumnMeta(this.selectedSensorList);

    if (this.selectedSensorList.includes('HSI')) {
      const modifiedColumns = [...this.displayedColumns];
      const modeIndex = modifiedColumns.indexOf('location');
      modifiedColumns.splice(modeIndex + 1, 0, 'bandOption');
      this.displayedColumns = modifiedColumns;
    }

    const hasSelectedTypes = this.SensorsTypes.some(
      (type) => type.selected === true,
    );

    if (!hasSelectedTypes) {
      if (
        this.isNightSensor ||
        this.isDailySubdaily ||
        this.isAllSensors ||
        this.isOpportunitySensors ||
        this.isObfuscatedSensors
      ) {
        this.clearCapabilityToggles();
        this.activeCapabilityToggle = null;
      }

      this.dataSource = new MatTableDataSource([]);
      if (this.enableSelection) {
        this.selection.clear();
        this.emitSensorSelection();
      }
      return;
    }
    this.selectedSensorTypes = '';
    this.FILTEREDSENSORS = [];

    this.SensorsTypes.forEach((type, index) => {
      if (this.SensorsTypes[index].selected === true) {
        this.selectedSensorTypes += type.value + '/';

        this.SENSORS.forEach((sensor) => {
          if (type.value === sensor.sensortype) {
            // Apply extra filter if SAR or InSAR
            if (
              (type.value === 'SAR' &&
                this.selectedSARBandType &&
                this.selectedSARBandType !== 'All' &&
                this.selectedSARBandType !== sensor?.tooltip) ||
              (type.value === 'InSAR' &&
                this.selectedInSARBandType &&
                this.selectedInSARBandType !== 'All' &&
                this.selectedInSARBandType !== sensor?.tooltip)
            ) {
              return;
            }

            const existId = this.FILTEREDSENSORS.findIndex(
              (ele) => JSON.stringify(ele) === JSON.stringify(sensor),
            );

            if (existId === -1) {
              const matchesAvailability = this.isAllSensors
                ? !sensor.enabled
                : !!sensor.enabled;
              const matchesNight = !this.isNightSensor || !!sensor.nightvision === true || sensor.nightvision === undefined;
              const matchesDaily =
                !this.isDailySubdaily || !!sensor.high_cadence;
              const matchesOpportunity =
                !this.isOpportunitySensors || !!sensor.feasibility;
              const matchesObfuscated =
                !this.isObfuscatedSensors || !!sensor.isObfuscated;

              if (
                matchesAvailability &&
                matchesNight &&
                matchesDaily &&
                matchesOpportunity &&
                matchesObfuscated
              ) {
                this.FILTEREDSENSORS.push(sensor);
              }
            }
          }
        });
      }
    });
    this.initializeData();
    if (!e.selected) {
      // Selection has already been cleared above; keep this block focused on table rebuild.

      const AVAILABLESENSORSFilter = this.AVAILABLESENSORS.filter(
        (el) => {
          const matchesAvailability = this.isAllSensors
            ? el.enabled === false
            : el.enabled === true;
          const matchesNight = !this.isNightSensor || el.nightvision === true || el.nightvision === undefined;
          const matchesDaily =
            !this.isDailySubdaily || el.high_cadence === true;
          const matchesOpportunity =
            !this.isOpportunitySensors || el.feasibility === true;
          const matchesObfuscated =
            !this.isObfuscatedSensors || el.isObfuscated === true;

          return (
            matchesAvailability &&
            matchesNight &&
            matchesDaily &&
            matchesOpportunity &&
            matchesObfuscated
          );
        }
      );
      this.selectedSensorList.length == 0
        ? this.rebuildTable(this.AVAILABLESENSORS)
        : '';
      this.AVAILABLESENSORS = AVAILABLESENSORSFilter;
      this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
      this.dataSource.sort = this.sort;
      this.updateSelectionAfterDataSourceChange();
      this.selectedSensors = [];
      this.AVAILABLESENSORS.forEach((operator) => {
        if (operator.checked) this.selectedSensors.push(operator);
      });
      this.emitSensorSelection();
    }

    if (this.FILTEREDSENSORS.length === 0) {
      this.dataSource = undefined;

      // this.dataSource = new MatTableDataSource([]);
    } else {
      this.FILTEREDSENSORS.sort(function (a, b) {
        return -(a.enabled - b.enabled);
      });
    }
  }

  rebuildTable(filteredSensors: any) {
    this.nameONA = 'ONA/Look/Grazing Angle';
    this.showColumn = true;
    this.lbandOnly = false;
    this.columnResolution = 'Resolution';
    this.aisOnly = true;
    this.tripleHeader = false;
    this.resolutionColumnTooltip = 'Spatial or pixel resolution, depending on ground sample distance (GSD) or re-sampled';
    this.onaTooltip =
      'ONA: Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.' +
      '\n' +
      'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
      '\n' +
      'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';

    this.displayedColumns = [
      'operator',
      'location',
      'band',
      'preview',
      'sattarcking',
      'mode',
      'resolution',
      'swath',
      'area_calculated',
      'cloudcovers',
      'ONA',
      'unitcost',
      'holdback',
      'advance',
      'cost',
      'opportunity',
      'footprint',
      'clientInfo',
      'eula',
    ];

    // let selectedSensorList:any = [];
    // filteredSensors.filter((sensor:any)=>{
    //   selectedSensorList.push(sensor.sensortype);
    // })
    const selectedSensorList: string[] = (filteredSensors || []).reduce(
      (acc: string[], sensor: any) => {
        const sensorType = sensor?.sensortype;
        if (
          typeof sensorType === 'string' &&
          sensorType.length > 0 &&
          !acc.includes(sensorType)
        ) {
          acc.push(sensorType);
        }
        return acc;
      },
      []
    );

    if (selectedSensorList?.length === 1 && selectedSensorList[0] === 'MSI') {
      this.nameONA = 'ONA';
      this.onaTooltip =
        'Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.';
    }

    if (
      selectedSensorList?.length === 1 &&
      (selectedSensorList.includes('SAR') ||
        selectedSensorList.includes('InSAR'))
    ) {
      this.nameONA = 'Look/Grazing Angle';
      this.onaTooltip =
        'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
        '\n' +
        'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
      this.showColumn = false;

      this.displayedColumns = [
        'operator',
        'location',
        'band',
        'preview',
        'sattarcking',
        'mode',
        'resolution',
        'swath',
        'area_calculated',
        'ONA',
        'unitcost',
        'holdback',
        'advance',
        'cost',
        'opportunity',
        'footprint',
        'clientInfo',
        'eula',
      ];
    } else if (
      selectedSensorList?.length === 2 &&
      selectedSensorList.includes('SAR') &&
      selectedSensorList.includes('InSAR')
    ) {
      this.nameONA = 'Look/Grazing Angle';
      this.onaTooltip =
        'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
        '\n' +
        'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
      this.showColumn = false;

      this.displayedColumns = [
        'operator',
        'location',
        'band',
        'preview',
        'sattarcking',
        'mode',
        'resolution',
        'swath',
        'area_calculated',
        'ONA',
        'unitcost',
        'holdback',
        'advance',
        'cost',
        'opportunity',
        'footprint',
        'clientInfo',
        'eula',
      ];
    } else if (
      selectedSensorList.includes('SAR') ||
      selectedSensorList.includes('InSAR')
    ) {
      this.nameONA = 'ONA/Look/Grazing Angle';
      this.onaTooltip =
        'ONA: Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.' +
        '\n' +
        'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
        '\n' +
        'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
      this.showColumn = true;
      this.displayedColumns = [
        'operator',
        'location',
        'band',
        'preview',
        'sattarcking',
        'mode',
        'resolution',
        'swath',
        'area_calculated',
        'cloudcovers',
        'ONA',
        'unitcost',
        'holdback',
        'advance',
        'cost',
        'opportunity',
        'footprint',
        'clientInfo',
        'eula',
      ];
    } else {
      this.nameONA = 'ONA';
      this.onaTooltip =
        'Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.';
    }

    if (
      (selectedSensorList.includes('Stereo') ||
        selectedSensorList.includes('MSI') ||
        selectedSensorList.includes('HSI') || selectedSensorList.includes('TIR')) &&
      !this.currentUser.allocated &&
      this.hasFeature(VALUE_ADDED_DATA_PRODUCTS)
    ) {
      const modifiedColumns = [...this.displayedColumns];
      const modeIndex = modifiedColumns.indexOf('mode');
      modifiedColumns.splice(modeIndex + 1, 0, 'dem');
      this.displayedColumns = modifiedColumns;
    }

    if (selectedSensorList.includes('SAR')) {
      this.showLooks = true;
      const resolutionIndex = this.displayedColumns.indexOf('resolution');
      if (resolutionIndex !== -1) {
        this.displayedColumns.splice(resolutionIndex + 1, 0, 'looks');
      }
    }

    if (selectedSensorList.includes('RF- comms')) {
      this.lband = true;
      const resolutionIndex = this.displayedColumns.indexOf('resolution');
      if (resolutionIndex !== -1) {
        this.displayedColumns.splice(
          resolutionIndex + 1,
          0,
          'signalOfInterest',
        );
      }
    }

    this.updateResolutionColumnMeta(selectedSensorList);

    if (selectedSensorList.includes('HSI')) {
      const modifiedColumns = [...this.displayedColumns];
      const modeIndex = modifiedColumns.indexOf('location');
      modifiedColumns.splice(modeIndex + 1, 0, 'bandOption');
      this.displayedColumns = modifiedColumns;
    }

    // rebuildTable overwrites `displayedColumns`; ensure the selection column is preserved
    // when this component is used in selectable mode.
    this.ensureSelectColumn();
    
    // this.initializeData();
  }

  toggleAll() {
    this.onCapabilityToggleChange('upcoming', this.isAllSensors);
  }

  toggleDailySubdaily() {
    this.onCapabilityToggleChange('dailySubdaily', this.isDailySubdaily);
  }
  
  toggleOpportunitySensors() {
    this.onCapabilityToggleChange('opportunity', this.isOpportunitySensors);
  }

  toggleObfuscatedSensors() {
    this.onCapabilityToggleChange('obfuscated', this.isObfuscatedSensors);
  }

  toggleNightSensors() {
    this.onCapabilityToggleChange('night', this.isNightSensor);
  }

  onCapabilityToggleChange(toggle: string, checked: boolean): void {
    if (checked) {
      this.setExclusiveCapabilityToggle(toggle);
      this.activeCapabilityToggle = toggle;
      this.autoSelectAllSensorTypesWhenToggleEnabled();
    } else if (this.activeCapabilityToggle === toggle) {
      this.clearCapabilityToggles();
      this.activeCapabilityToggle = null;
    }

    this.refreshFiltersForCurrentSelections();
  }

  private setExclusiveCapabilityToggle(toggle: string): void {
    this.isNightSensor = toggle === 'night';
    this.isDailySubdaily = toggle === 'dailySubdaily';
    this.isAllSensors = toggle === 'upcoming';
    this.isOpportunitySensors = toggle === 'opportunity';
    this.isObfuscatedSensors = toggle === 'obfuscated';
  }

  private clearCapabilityToggles(): void {
    this.isNightSensor = false;
    this.isDailySubdaily = false;
    this.isAllSensors = false;
    this.isOpportunitySensors = false;
    this.isObfuscatedSensors = false;
  }

  private refreshFiltersForCurrentSelections(): void {
    this.resetSorting();
    const selectedIndex = this.SensorsTypes?.findIndex((type) => type.selected);

    if (selectedIndex > -1) {
      this.updateAllComplete(this.SensorsTypes[selectedIndex], selectedIndex, 1);
      return;
    }

    this.updateAllComplete({ selected: true, value: null, name: 'All' }, 0, 1);
  }

  onSensorTypeChange(sensor: any, index: number): void {
    this.resetSorting();
    this.updateAllComplete(sensor, index, 0);
  }

  selectAllSensorTypes(): void {
    this.onAllSensorTypesChange(true);
  }

  clearSensorTypes(): void {
    this.onAllSensorTypesChange(false);
  }

  onAllSensorTypesChange(checked: boolean): void {
    if (this.isBulkSensorTypesLoading) {
      return;
    }

    if (!Array.isArray(this.SensorsTypes)) {
      this.isAllSensorTypesChecked = false;
      return;
    }

    if (!checked) {
      this.selectedSensorList = [];
    }

    this.isBulkSensorTypesLoading = true;

    // Yield one frame so Angular can paint the loading state before heavy rebuild.
    setTimeout(() => {
      try {
        const selectableTypes = this.getSelectableSensorTypes();

        selectableTypes.forEach((type) => {
          type.selected = checked;
        });

        if (checked) {
          this.selectedSARBandType = 'All';
          this.selectedInSARBandType = 'All';
        } else {
          this.selectedSARBandType = null;
          this.selectedInSARBandType = null;
        }

        this.syncAllSensorTypesCheckbox();

        const firstSelectableIndex = this.SensorsTypes.findIndex((type) =>
          this.isSensorTypeSelectable(type),
        );

        if (firstSelectableIndex > -1) {
          this.resetSorting();
          this.updateAllComplete(
            this.SensorsTypes[firstSelectableIndex],
            firstSelectableIndex,
            1,
          );
        }
      } finally {
        this.isBulkSensorTypesLoading = false;
      }
    }, 0);
  }

  async ccChange(cCover: any, indx: number, row: any) {
    if (cCover) {
      const ccFactor = this.AVAILABLESENSORS[indx]?.cloudnew[cCover];
      this.cloudFactor = ccFactor;
      this.AVAILABLESENSORS[indx].selectedCC = cCover;
      this.AVAILABLESENSORS[indx].cloudFactor = ccFactor;
      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency,
      );

      if (idx > -1) {
        this.calculateUnitcost(indx, idx);
      }
    }
  }

  async ONAOption(cCover: any, indx: number, row: any, type: any) {
    if (cCover) {
      if (!cCover?.key) {
        cCover.key = cCover.ona ? cCover.ona : cCover.key;
        cCover.value = cCover.value ? cCover.value : cCover.onaUplift;
      }
      if (cCover?.ona && type === 1) {
        if (this.AVAILABLESENSORS[indx].resolution.length < 2) {
          let newResoution: any = {
            key: '0',
            value: cCover.resolution,
            originalResolution: cCover.forResolution,
          };
          if (row?.key !== OPERATORS.GEOSAT) {
            newResoution.bands =
              cCover?.bands ?? this.AVAILABLESENSORS[indx].resolution[0]?.bands;
          }
          if (cCover?.mode_value) {
            newResoution.mode_value = cCover?.mode_value;
          }
          this.AVAILABLESENSORS[indx].resolution = [newResoution];
          this.AVAILABLESENSORS[indx].selectedResolution = newResoution;
        }
        if (this.AVAILABLESENSORS[indx].resolution.length > 1) {
          const resolutionArray = this.createResolutionArray(
            this.AVAILABLESENSORS[indx]?.onaWithResolution,
            cCover?.ona,
            this.AVAILABLESENSORS[indx].resolution,
            this.AVAILABLESENSORS[indx].key,
          );
          this.AVAILABLESENSORS[indx].resolution = resolutionArray;
          this.AVAILABLESENSORS[indx].selectedResolution = resolutionArray[0];
          this.AVAILABLESENSORS[indx].selectedResolutionValue =
            resolutionArray[0]?.value;
          if (row?.key !== OPERATORS.GEOSAT) {
            this.AVAILABLESENSORS[indx].modeResetValue = null;
            this.AVAILABLESENSORS[indx].selectedModes = [row?.collection_mode[0]];
            this.AVAILABLESENSORS[indx].modeSelected = [row?.collection_mode[0]];
          }

          if (row?.key === OPERATORS.STE && row?.sensor === 'MSI') {
            this.resetCost(
              row,
              this.AVAILABLESENSORS[indx].selectedResolution,
              indx,
            );
          }
        }
      }

      const ccFactor = cCover.value;
      this.ONAFactor = ccFactor;
      this.AVAILABLESENSORS[indx].selectedONA = cCover.ona
        ? cCover.ona
        : cCover.key;
      this.AVAILABLESENSORS[indx].selectedONAOption = cCover;
      this.AVAILABLESENSORS[indx].ONAFactor = ccFactor;
      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency,
      );

      if (idx > -1) {
        this.calculateUnitcost(indx, idx);
      }
    }

    if (
      row.key === OPERATORS.HEAD ||
      row.key === OPERATORS.GOKTURK ||
      row.key === OPERATORS.AT21 ||
      row.key === OPERATORS.GEOSAT
    ) {
      this.resetResolution(
        this.AVAILABLESENSORS[indx].selectedModes[0],
        indx,
        row?.key,
      );
    }

    this.syncSensorTooltip(indx);
  }

  async toggleSelect(checked: boolean) {
    this.SENSORS.forEach((sensor, indx) => {
      if (sensor.enabled) {
        this.SENSORS[indx].checked = checked;
      }
    });
  }
  async taskingOption(
    latency: any,
    rowIndx: number,
    row: any,
    type: number,
    userClick: boolean = false,
  ) {
    if (userClick) {
      row.isUserSelection = true;
      this.AVAILABLESENSORS[rowIndx].selectedTaskingTier = true;
    }
    if (this.AVAILABLESENSORS[rowIndx].prevent === true) {
      this.AVAILABLESENSORS[rowIndx].prevent = false;
      this.AVAILABLESENSORS[rowIndx].checked = false;
    }

    if (row?.latency) {
      const latencyFilter = row?.latency.filter(
        (el: any) => el.name === latency,
      );
      let latencyKey = latencyFilter[0];

      const keysToInclude = ['key', 'name', 'latency'];
      const latencyArray = latencyFilter.map((item) => {
        const newItem: any = {};
        keysToInclude.forEach((key) => (newItem[key] = item[key]));
        return newItem;
      });

      if (
        latencyKey.key === 'rush' ||
        latencyKey.key === 'RR' ||
        latencyKey.key === 'emergency' ||
        (latencyKey.key === 'priority' &&
          row?.key === OPERATORS.STE &&
          row.sensor != 'SAR')
      ) {
        this.AVAILABLESENSORS[rowIndx].rushCloudCover = true;
        this.AVAILABLESENSORS[rowIndx].selectedCC = '';
      } else {
        if (this.AVAILABLESENSORS[rowIndx]?.cloudcovers) {
          this.AVAILABLESENSORS[rowIndx].selectedCC =
            this.AVAILABLESENSORS[rowIndx]?.cloudcovers[0]?.key;
          this.AVAILABLESENSORS[rowIndx].cloudValue = null;
        }
        this.AVAILABLESENSORS[rowIndx].rushCloudCover = false;
        this.ccChange(
          this.AVAILABLESENSORS[rowIndx].selectedCC,
          rowIndx,
          'row',
        );
      }

      if (latencyKey.key === 'priority' && row.key === OPERATORS.BLACKSKY) {
        this.AVAILABLESENSORS[rowIndx].selectedCC = '100%';
        this.AVAILABLESENSORS[rowIndx].cloudValue = null;
      } else if (
        latencyKey.key != 'standard' &&
        type != 0 &&
        row.key === OPERATORS.STE &&
        row.sensor === 'MSI'
      ) {
        this.AVAILABLESENSORS[rowIndx].selectedCC =
          this.AVAILABLESENSORS[rowIndx]?.cloudcovers[4]?.key;
        this.AVAILABLESENSORS[rowIndx].cloudValue = null;
      }

      if (this.FILTEREDSENSORS[rowIndx]?.checked)
        this.FILTEREDSENSORS[rowIndx].checked = true;

      this.AVAILABLESENSORS[rowIndx].selectedLatency = latency;
      this.AVAILABLESENSORS[rowIndx].selectedLatencyKey = latencyArray[0];
      this.AVAILABLESENSORS[rowIndx].latency.forEach((elem, i) => {
        if (elem.name === latency) {
          this.AVAILABLESENSORS[rowIndx].cost =
            this.AVAILABLESENSORS[rowIndx].latency[i].unitcost;
          this.AVAILABLESENSORS[rowIndx].unitcost =
            this.AVAILABLESENSORS[rowIndx].latency[i].unitcost;
          //if(this.AVAILABLESENSORS[rowIndx].key !== OPERATORS.SPIRE) {
          this.AVAILABLESENSORS[rowIndx].selectedCost =
            this.AVAILABLESENSORS[rowIndx].latency[i].unitcost;
          //}
          this.AVAILABLESENSORS[rowIndx].latency[i].selected = true;
        } else this.AVAILABLESENSORS[rowIndx].latency[i].selected = false;
      });

      if (row?.key === OPERATORS.WYVERN) {
        this.AVAILABLESENSORS[rowIndx].selectedHoldBackOption =
          row?.holdback.filter(
            (value) => value.type === row.selectedLatencyKey.key,
          )[0];
        this.AVAILABLESENSORS[rowIndx].holdBackValue = null;
        for (const [index, item] of row.latency.entries()) {
          let key = 'internalUse' + '_' + item.key;
          if (row?.pricing.hasOwnProperty(key)) {
            item.cost = row.pricing[key];
            item.unitcost = row.pricing[key];
          }
        }
        this.AVAILABLESENSORS[rowIndx].latency = row.latency;
        if (latencyKey.key === 'priority')
          this.AVAILABLESENSORS[rowIndx].minarea = 50;
        else this.AVAILABLESENSORS[rowIndx].minarea = 100;
      }

      this.holdBackOption(
        this.AVAILABLESENSORS[rowIndx].selectedHoldBackOption,
        rowIndx,
        row,
      );
      this.ONAOption(
        this.AVAILABLESENSORS[rowIndx].selectedONAOption,
        rowIndx,
        row,
        0,
      );

      const idx = this.AVAILABLESENSORS[rowIndx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[rowIndx].selectedLatency,
      );

      if (idx > -1) {
        this.calculateUnitcost(rowIndx, idx);
      }
    }
  }

  async holdBackOption(cCover: any, indx: number, row: any) {
    if (cCover) {
      const ccFactor = cCover?.value;
      this.holdBack = ccFactor;
      this.AVAILABLESENSORS[indx].selectedHoldBack = cCover?.key;
      this.AVAILABLESENSORS[indx].selectedHoldBackOption = cCover;
      this.AVAILABLESENSORS[indx].ccFactor = ccFactor;
      this.AVAILABLESENSORS[indx].holdbackFactor = ccFactor;
      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency,
      );

      if (idx > -1) {
        this.calculateUnitcost(indx, idx);
      }
    }
  }

  async modeOption(productMode: any, indx: number, row: any) {
    this.resolutionTooltip = true;
    this.AVAILABLESENSORS[indx].selectedModes = [];
    if (productMode?.isCaptureMode && !productMode?.isProductLevel) {
      this.AVAILABLESENSORS[indx].selectedMode = productMode.captureMode;
    } else if (productMode?.isProductLevel && !productMode?.isCaptureMode) {
      this.AVAILABLESENSORS[indx].selectedMode = productMode.productLevel;
    } else if (productMode?.isProductLevel && productMode?.isCaptureMode) {
      this.AVAILABLESENSORS[indx].selectedMode =
        productMode.captureMode + ' (' + productMode.productLevel + ')';
    }

    if (row?.key === OPERATORS.AT21) {
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
      if (productMode?.productLevel === 'L1') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value.includes('Bundle')) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      } else if (productMode?.productLevel === 'L4') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value.includes('Pan-sharpened')) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      } else {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value.includes('Both')) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      }

      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency,
      );

      if (idx > -1) {
        this.calculateUnitcost(indx, idx);
      }
    } else if (
      (row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS) &&
      row?.sensor === 'SAR'
    ) {
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
      if (productMode?.mode === 'PSPOT' || productMode?.mode == this.spotMode) {
        this.AVAILABLESENSORS[indx].resolution[1].disable = true;
        this.AVAILABLESENSORS[indx].resolution[0].disable = false;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[0];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[0].value;
        if (productMode?.mode === this.spotMode) {
          this.AVAILABLESENSORS[indx].selectedONA =
            this.AVAILABLESENSORS[indx].ONA[0].key;
          this.AVAILABLESENSORS[indx].selectedONAOption =
            this.AVAILABLESENSORS[indx].ONA[0];
          this.resetOna(indx, this.spotMode);
        }
      } else if (
        productMode?.mode === 'PSTRIP' ||
        productMode?.mode == this.stripMode
      ) {
        this.AVAILABLESENSORS[indx].resolution[1].disable = false;
        this.AVAILABLESENSORS[indx].resolution[0].disable = true;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[1];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[1].value;
        if (productMode?.mode === this.stripMode) {
          this.AVAILABLESENSORS[indx].selectedONA =
            this.AVAILABLESENSORS[indx].ONA[1].key;
          this.AVAILABLESENSORS[indx].selectedONAOption =
            this.AVAILABLESENSORS[indx].ONA[1];
          this.resetOna(indx, this.stripMode);
        }
      } else {
        this.AVAILABLESENSORS[indx].resolution[1].disable = false;
        this.AVAILABLESENSORS[indx].resolution[0].disable = false;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[0];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[0].value;
      }
    } else if (row?.key === OPERATORS.SYNSPECTIVE && row?.sensor === 'SAR') {
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
      if (productMode?.key === 'Area') {
        this.AVAILABLESENSORS[indx].resolution[0].disable = false;
        this.AVAILABLESENSORS[indx].resolution[1].disable = true;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[0];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[0].value;
      } else {
        this.AVAILABLESENSORS[indx].resolution[0].disable = true;
        this.AVAILABLESENSORS[indx].resolution[1].disable = false;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[1];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[1].value;
      }
    } else if (row?.key === OPERATORS.ISI && row?.sensor === 'Stereo') {
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
      if (productMode?.key != 'Bundle') {
        this.AVAILABLESENSORS[indx].resolution[0].disable = false;
        this.AVAILABLESENSORS[indx].resolution[1].disable = true;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[0];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[0].value;
      } else {
        this.AVAILABLESENSORS[indx].resolution[0].disable = true;
        this.AVAILABLESENSORS[indx].resolution[1].disable = false;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[1];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[1].value;
      }
    }
    if (row?.key === OPERATORS.CAPELLA) {
      this.applyCapellaResolutionConstraints(
        this.AVAILABLESENSORS[indx],
        productMode,
      );
    }

    this.AVAILABLESENSORS[indx].selectedModes = productMode;
    this.getTooltip(productMode, indx, row);
    const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
      (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency,
    );
    if (productMode?.length) {
      this.spot = false;
      this.strip = false;
      if (
        productMode[0]?.key.includes('Spot') &&
        (row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS)
      ) {
        this.spot = true;
      } else if (
        row?.key === OPERATORS.STE ||
        row?.key === OPERATORS.STE_TELEOS
      ) {
        this.strip = true;
      }

      this.AVAILABLESENSORS[indx].selectedMode = productMode[0].key;

      if (productMode[0]?.isCaptureMode && !productMode[0]?.isProductLevel) {
        this.AVAILABLESENSORS[indx].selectedMode = productMode[0].captureMode;
      } else if (
        productMode[0]?.isProductLevel &&
        !productMode[0]?.isCaptureMode
      ) {
        this.AVAILABLESENSORS[indx].selectedMode = productMode[0].productLevel;
      } else if (
        productMode[0]?.isProductLevel &&
        productMode[0]?.isCaptureMode
      ) {
        this.AVAILABLESENSORS[indx].selectedMode =
          productMode[0].captureMode + ' (' + productMode[0].productLevel + ')';
      } else if (row?.key === OPERATORS.WEATHEREX) {
        this.AVAILABLESENSORS[indx].selectedMode = productMode
          .map((m: any) => m?.name || m?.key)
          .join(', ');
      }

      this.getTooltip(productMode[0], indx, row);
    } else if (productMode.length === 0) {
      this.spot = false;
      this.strip = false;
      this.getTooltip(row?.collection_mode[0], indx, row);
      this.AVAILABLESENSORS[indx].selectedModes = [];
      this.AVAILABLESENSORS[indx].selectedModes =
        this.AVAILABLESENSORS[indx].modeSelected;
    } else {
      this.AVAILABLESENSORS[indx].selectedModes = [];
      this.AVAILABLESENSORS[indx].selectedModes.push(productMode);
    }

    if (row?.key === OPERATORS.UMBRA) {
      const { isUmbraScan, looks } = applyUmbraModeConstraints(
        this.AVAILABLESENSORS[indx],
        productMode,
      );

      let sceneSize = this.AVAILABLESENSORS[indx].selectedModes[0].value;
      this.AVAILABLESENSORS[indx].numberOfLooks = looks;

      const umbraPrice = isUmbraScan
        ? getUmbraScenePrice(this.AVAILABLESENSORS[indx].selectedResolution, sceneSize)
        : this.AVAILABLESENSORS[indx].selectedResolution?.sceneSizePricing[
            sceneSize
          ][looks];

      row.latency[0].cost = umbraPrice;
      row.latency[0].unitcost = umbraPrice;
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[0].name, indx, row, 1);
    }

    if (row?.key === OPERATORS.ICEYE) {
      const iceyeStrategy = this.operatorStrategyFactory.getStrategy(row.key);
      iceyeStrategy?.applyResolutionConstraints?.(this.AVAILABLESENSORS[indx], productMode);
      iceyeStrategy?.syncLatencyCosts?.(row);
      const resolvedLatency = iceyeStrategy?.resolveActiveLatency?.(row);
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(resolvedLatency?.name ?? row.latency[0]?.name, indx, row, 1);
    }

    if (row?.key === OPERATORS.BLACKSKY || row?.key === OPERATORS.OSK) {
      if (productMode.sceneSize)
        this.AVAILABLESENSORS[indx].minarea = productMode.sceneSize;
    }

    if (row?.key === OPERATORS.GHG) {
      const selectedIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
        (item) => item.selected === true,
      );
      row.latency = row.latency.map((latencyItem) => {
        const matchingMode = row.selectedModes[0].cost.find(
          (mode) => mode[latencyItem.key] !== undefined,
        );
        return {
          ...latencyItem,
          cost: matchingMode ? matchingMode[latencyItem.key] : null,
          unitcost: matchingMode ? matchingMode[latencyItem.key] : null,
        };
      });
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
    }

    if (row?.key === OPERATORS.STE && row?.sensor === 'MSI') {
      this.resetCost(row, this.AVAILABLESENSORS[indx].selectedResolution, indx);
    }

    if (
      row?.key === OPERATORS.CAPELLA ||
      row?.key === OPERATORS.BLACKSKY ||
      row?.key === OPERATORS.GOKTURK ||
      row?.key === OPERATORS.ECURS ||
      row?.key === OPERATORS.ECURS_L ||
      row?.key === OPERATORS.SDS
    ) {
      let pricingArray = row.selectedModes[0]?.pricing;
      const selectedIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
        (item) => item.selected === true,
      );
      for (const latencyItem of this.AVAILABLESENSORS[indx].latency) {
        const key = latencyItem.key;
        if (pricingArray && pricingArray.hasOwnProperty(key)) {
          const newCost = Number(pricingArray[key]);
          latencyItem.cost = newCost;
          latencyItem.unitcost = newCost;
        }
      }

      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
    }

    let minimumArea: any;
    if (
      (row.unit === 'scene' || row.unit === 'week' || row.unit === 'day') &&
      row.key != OPERATORS.BLACKSKY
    ) {
      if (row.tooltipValue) {
        minimumArea = this.extractAndCalculateValues(row.tooltipValue);
        this.AVAILABLESENSORS[indx].minimumAreaSize = minimumArea;
      } else if (row.minimumArea) {
        minimumArea = this.extractAndCalculateValues(row.minimumArea);
        this.AVAILABLESENSORS[indx].minimumAreaSize = minimumArea;
      }
    } else {
      minimumArea = row.minarea;
      this.AVAILABLESENSORS[indx].minimumAreaSize = minimumArea;
    }

    if (row?.key === OPERATORS.ICEYE && productMode?.minArea != null) {
      this.AVAILABLESENSORS[indx].minimumAreaSize = productMode.minArea;
      this.AVAILABLESENSORS[indx].minimumArea = productMode.value;
    }

    if (
      row?.key === OPERATORS.HEAD ||
      row?.key === OPERATORS.GOKTURK ||
      row?.key === OPERATORS.GHG ||
      row?.key === OPERATORS.ECURS ||
      row?.key === OPERATORS.ECURS_L ||
      row?.key === OPERATORS.SATELLITEVU_VANZYL ||
      row?.key === OPERATORS.GEOSAT
    ) {

      // GEOSAT: mode selection drives ONA. Snap to the selected mode's default
      // supported ONA BEFORE resetResolution runs so the ONA-filtered resolution
      // list stays aligned with the selected mode.
      if (row?.key === OPERATORS.GEOSAT) {
        const geosatStrategy = this.operatorStrategyFactory.getStrategy(OPERATORS.GEOSAT) as any;
        const defaultOna: string | null =
          geosatStrategy?.getDefaultOnaForMode?.(productMode, this.AVAILABLESENSORS[indx]) ?? null;
        if (defaultOna && this.AVAILABLESENSORS[indx].selectedONA !== defaultOna) {
          const onaOptions: any[] = this.AVAILABLESENSORS[indx].ONA ?? [];
          const targetOna = onaOptions.find((o: any) => (o.ona ?? o.key) === defaultOna);
          if (targetOna) {
            this.AVAILABLESENSORS[indx].selectedONA = defaultOna;
            this.AVAILABLESENSORS[indx].selectedONAOption = targetOna;
            this.AVAILABLESENSORS[indx].selectedItem = targetOna;
            this.AVAILABLESENSORS[indx].ONAFactor = Number(
              targetOna.onaUplift ?? targetOna.value ?? 1,
            );
            const resolutionArray = this.createResolutionArray(
              this.AVAILABLESENSORS[indx].onaWithResolution,
              defaultOna,
              this.AVAILABLESENSORS[indx].resolution,
              row.key,
            );
            if (resolutionArray.length > 0) {
              this.AVAILABLESENSORS[indx].resolution = resolutionArray;
            }
          }
        }
      }

      this.resetResolution(productMode, indx, row?.key);

      // GEOSAT: keep unit cost in sync after resolution constraints are applied.
      if (row?.key === OPERATORS.GEOSAT) {
        this.recalculateSelectedCostForRow(indx);
      }

      // SatelliteVu: mode can change selected resolution; keep unit cost in sync.
      if (row?.key === OPERATORS.SATELLITEVU_VANZYL) {
        const latencyIdx = this.AVAILABLESENSORS[indx].latency.findIndex(
          (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency,
        );
        if (latencyIdx > -1) {
          this.calculateUnitcost(indx, latencyIdx);
        }
      }
    }

    if (row?.key === OPERATORS.SATELLOGIC && row?.sensortype == 'MSI') {
      this.resetResolution(productMode, indx, row?.key);
      let minimumArea = this.extractAndCalculateValues(row.tooltipValue);
      this.AVAILABLESENSORS[indx].minimumAreaSize = minimumArea;
      this.AVAILABLESENSORS[indx].minarea = minimumArea;
    }

    this.showSwath = this.AVAILABLESENSORS.some((s) =>
      s.selectedModes?.[0]?.swathWidth
    );
    this.syncSensorTooltip(indx);
    if (row?.key === OPERATORS.OSK) {
      if(productMode?.imaging_mode === "Linescan") {
        this.AVAILABLESENSORS[indx].selectedCost =  row?.pricing?.standard?.POI_scan_mode;
        this.AVAILABLESENSORS[indx].unitcost =  row?.pricing?.standard?.POI_scan_mode;
     } else{
      this.AVAILABLESENSORS[indx].selectedCost = row?.pricing?.standard?.POI;
        this.AVAILABLESENSORS[indx].unitcost = row?.pricing?.standard?.POI;
     }
       if (
      this.AVAILABLESENSORS[indx].userCost > 0 &&
      this.AVAILABLESENSORS[indx].selectedCost > 0
    ) {
      this.AVAILABLESENSORS[indx].selectedCost =
        this.AVAILABLESENSORS[indx].selectedCost *
        this.AVAILABLESENSORS[indx].userCost;
    }
    }
     if (idx > -1 && this.getModeResolutionPrice(this.AVAILABLESENSORS[indx], this.AVAILABLESENSORS[indx].selectedResolution) != null) {
      this.calculateUnitcost(indx, idx);
    }

    if (row?.key === OPERATORS.OSK) {
        if(productMode?.key === "scan_mode") {
          this.AVAILABLESENSORS[indx].selectedCost = row?.pricing?.standard?.POI_scan_mode;
          this.AVAILABLESENSORS[indx].unitcost = row?.pricing?.standard?.POI_scan_mode;
          } else{
            this.AVAILABLESENSORS[indx].selectedCost = row?.pricing?.standard?.POI;
            this.AVAILABLESENSORS[indx].unitcost = row?.pricing?.standard?.POI;
            }
              if (
            this.AVAILABLESENSORS[indx].userCost > 0 &&
            this.AVAILABLESENSORS[indx].selectedCost > 0
          ) {
              this.AVAILABLESENSORS[indx].selectedCost = Number(
                  (
                    this.AVAILABLESENSORS[indx].selectedCost *
                    this.AVAILABLESENSORS[indx].userCost
                  ).toFixed(2)
                );
        }
  
        for (const latencyItem of this.AVAILABLESENSORS[indx].latency) {
          
          const key = latencyItem.key;
          let lat1 = this.AVAILABLESENSORS[indx].selectedModes
          let mode_key = this.AVAILABLESENSORS[indx].selectedModes[0]?.key;
  
            const newCost = mode_key == 'scan_mode' ? Number(row?.pricing[key]?.POI_scan_mode) : Number(row?.pricing?.[key]?.POI);
            latencyItem.cost = newCost;
            latencyItem.unitcost = newCost;
  
        }
      }
      if (row?.key === OPERATORS.CONSTELLR) {
        // Extract cost directly from productMode object
        const modeCost = productMode?.cost;
        if (modeCost !== undefined && modeCost !== null) {
          this.AVAILABLESENSORS[indx].selectedCost = modeCost;
          this.AVAILABLESENSORS[indx].unitcost = modeCost;

          // Update all latency items with the same cost from the selected mode
          if (this.AVAILABLESENSORS[indx].latency && this.AVAILABLESENSORS[indx].latency.length > 0) {
            for (const latencyItem of this.AVAILABLESENSORS[indx].latency) {
              latencyItem.cost = modeCost;
              latencyItem.unitcost = modeCost;
            }
          }
        }
      }

    this.resetValueAddedDropdown(indx, row);
    if (row?.key === OPERATORS.CAPELLA) {
      this.cd.detectChanges();
    }
  }
  async resetOna(indx: number, mode: string) {
    if (mode === this.spotMode) {
      this.AVAILABLESENSORS[indx].ONA[0].enabled = true;
      this.AVAILABLESENSORS[indx].ONA[1].enabled = false;
    } else {
      this.AVAILABLESENSORS[indx].ONA[0].enabled = false;
      this.AVAILABLESENSORS[indx].ONA[1].enabled = true;
    }
  }

  private applySatelliteVuInitConstraints(indx: number) {
    const row = this.AVAILABLESENSORS?.[indx];
    const mode = row?.selectedModes?.[0];
    if (!mode) return;

    // GEOSAT and SatVu go through resetResolution because they need additional
    // post-constraint work (recalculateSelectedCostForRow, value-added resets) that
    // lives outside the strategy. They require mode.resolution to be present.
    if (row?.key === OPERATORS.SATELLITEVU_VANZYL || row?.key === OPERATORS.GEOSAT) {
      if (!mode?.resolution) return;
      this.resetResolution(mode, indx, row.key);
      if (row?.key === OPERATORS.GEOSAT) {
        this.syncSensorTooltip(indx);
        return;
      }
      this.syncSensorTooltip(indx);
      if (row?.selectedResolution) {
        row.valueAddedAction = this.filterValueAddedData(row);
      }
      return;
    }

    // Generic path: let the strategy apply resolution constraints if it supports them.
    // The strategy encapsulates whether it uses distance, resolution, or any other field.
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    strategy?.applyResolutionConstraints?.(row, mode);
    if (row?.key === OPERATORS.ICEYE && mode?.minArea != null) {
      row.minimumAreaSize = mode.minArea;
    }
  }

  private applyCapellaResolutionConstraints(row: any, productMode: any): any {
    if (
      row?.key !== OPERATORS.CAPELLA ||
      !Array.isArray(row?.resolution) ||
      row.resolution.length < 2
    ) {
      return row?.selectedResolution;
    }

    const mode = Array.isArray(productMode) ? productMode[0] : productMode;
    const enabledResolutionKey =
      mode?.mode_type === 'spotlight_ultra'
        ? 1
        : mode?.mode_type === 'spotlight'
        ? 2
        : null;

    if (enabledResolutionKey == null) {
      return row?.selectedResolution;
    }

    row.resolution = row.resolution.map((item: any) => ({
      ...item,
      disable: Number(item.key) !== enabledResolutionKey,
    }));

    const selectedResolution = row.resolution.find(
      (item: any) => Number(item.key) === enabledResolutionKey,
    ) ?? row.selectedResolution;

    row.selectedResolution = selectedResolution;
    row.selectedResolutionValue = selectedResolution?.value;
    row.selectedResolutionData = selectedResolution;
    return selectedResolution;
  }

  private sortLatencyByTierPref(sensor: any): void {
    if (!Array.isArray(sensor.latency)) return;
    const getSortCost = (item: any): number => sensor?.key === OPERATORS.GEOSAT
      ? (item.taskingWindowCost ?? ((item.reactionUpliftCost ?? 0) + (item.responseUpliftCost ?? 0)))
      : item.unitcost;
    if (this.taskTierPref === 'low') {
      sensor.latency.sort((a: any, b: any) => getSortCost(a) - getSortCost(b));
    } else if (this.taskTierPref === 'high') {
      sensor.latency.sort((a: any, b: any) => getSortCost(b) - getSortCost(a));
    }
  }

  private getInitialSensorTooltip(sensor: any, selectedModes: any[]): string {
    if (sensor?.key === OPERATORS.GEOSAT) {
      return selectedModes?.[0]?.bands ?? '';
    }

    return sensor?.tooltip ?? '';
  }

  private syncSensorTooltip(
    indx: number,
    resolution: any = this.AVAILABLESENSORS?.[indx]?.selectedResolution,
  ): void {
    const row = this.AVAILABLESENSORS?.[indx];
    if (!row) return;

    if (row?.key === OPERATORS.GEOSAT) {
      row.sensorTooltip = row?.selectedModes?.[0]?.bands ?? '';
      return;
    }

    if (row?.key === OPERATORS.SATELLITEVU_VANZYL) {
      const mode = row?.selectedModes?.[0];
      const combinedBandsTooltip = getSatelliteVuBandsTooltip(row, mode);
      if (combinedBandsTooltip) {
        row.sensorTooltip = combinedBandsTooltip;
        return;
      }
    }

    if (resolution?.bands) {
      row.sensorTooltip = resolution.bands;
    }
  }

  resetResolution(productMode, indx, operatorKey) {
    this.AVAILABLESENSORS[indx].selectedResolutionData = null;
    let item = this.AVAILABLESENSORS[indx];
    if (
      (productMode?.key === 'L3C' &&
        operatorKey === OPERATORS.HEAD &&
        item.sensor != 'HSI') ||
      (productMode?.productLevel === 'L2B' &&
        operatorKey === OPERATORS.GOKTURK &&
        productMode?.key.includes('pan_sharpened'))
    ) {
      for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('Pan-sharpened')) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
        } else {
          items.disable = true;
        }
      }
    } else if (productMode?.key === 'L3D' && operatorKey === OPERATORS.HEAD) {
      for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('TCI')) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
        } else {
          items.disable = true;
        }
      }
    } else if (
      productMode?.key != 'L3D' &&
      operatorKey === OPERATORS.HEAD &&
      item.sensor === 'HSI'
    ) {
      for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('TCI')) {
          items.disable = true;
        } else {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = item.resolution[1];
          this.AVAILABLESENSORS[indx].selectedResolutionValue =
            item.resolution[1].value;
        }
      }
    } else if (operatorKey === OPERATORS.AT21) {
      if (productMode?.productLevel === 'L1') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value.includes('Bundle')) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      } else if (productMode?.productLevel === 'L4') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value.includes('Pan-sharpened')) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      } else {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value.includes('Both')) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      }
    } else if (
      operatorKey === OPERATORS.ECURS ||
      operatorKey === OPERATORS.ECURS_L
    ) {
      if (productMode.resolution) {
        const productResolutions = productMode.resolution;
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          // Check if the resolution exactly matches any value in productMode.resolution
          let isMatched = false;

          for (const res of productResolutions) {
            if (items.value === res) {
              isMatched = true;
              break;
            }
          }

          if (isMatched) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      } else if (productMode?.mode === 'SL') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.key === 1) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      } else if (productMode?.mode === 'SM') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.key === 2) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      } else if (productMode?.mode === 'NSS') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.key === 3) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      } else {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.key === 4) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      }
    } else if (operatorKey === OPERATORS.GHG) {
      if (productMode?.productLevel.includes('Onshore')) {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value === '25m') {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      } else if (productMode?.productLevel.includes('Offshore')) {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value === '30-80m') {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      }
    } else if (operatorKey === OPERATORS.SATELLOGIC && item?.sensor === 'MSI') {
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
    
      const resolutions = this.AVAILABLESENSORS[indx]?.resolution || [];
    
      for (const [index, items] of resolutions.entries()) {
        if (
          Array.isArray(productMode.resolution) &&
          productMode.resolution.length > 0 &&
          items.value.includes(productMode.resolution[0])
        ) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
    } else {
          items.disable = true;
        }
      }
    } else if (operatorKey === OPERATORS.GEOSAT) {
      // Geosat: constrain resolution options based on selected mode's allowed resolution list.
      const strategy = this.operatorStrategyFactory.getStrategy(operatorKey);
      strategy?.applyResolutionConstraints?.(this.AVAILABLESENSORS[indx], productMode);
      // Update tier costs using strategy (mode.unitCost + tier.upliftCost)
      this.recalculateSelectedCostForRow(indx);
    } else if (operatorKey === OPERATORS.SATELLITEVU_VANZYL) {
      // SatelliteVu_VanZyl (HydroSat/TIR) - Reset resolution based on mode
      applySatelliteVuResolutionConstraints(this.AVAILABLESENSORS[indx], productMode);
    } else if (
      (productMode?.key === 'spot_L3A_pan_sharpened' ||
        productMode?.key === 'strip_L3A_pan_sharpened' ||
        productMode?.key === 'tristereo_L3A_pan_sharpened' ||
        productMode?.key === 'stereo_L3A_pan_sharpened') &&
      operatorKey === OPERATORS.GOKTURK &&
      (item?.sensor === 'MSI' ||
        item?.sensor === 'Stereo' ||
        item?.sensor === 'Tristereo')
    ) {
        for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('Pan-sharpened')) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
        } else {
          items.disable = true;
        }
      } 
    } else {
      for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('Bundle')) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
        } else {
          items.disable = true;
        }
      }
    }
    this.resetValueAddedDropdown(indx, this.AVAILABLESENSORS[indx]);
  }

  async resolutionChange(resolution: any, indx: number, row: any) {
    if (row?.key === OPERATORS.UMBRA) {
      const isUmbraScan = isUmbraScanMode(row);
      this.AVAILABLESENSORS[indx].selectedLooks = null;
      let sceneSize = this.AVAILABLESENSORS[indx].selectedModes[0].value;
      let looks = resolution?.numberOfLooks?.[0];
      this.AVAILABLESENSORS[indx].numberOfLooks = looks;

      if (!isUmbraScan && sceneSize === 'SAR Video' && Array.isArray(this.AVAILABLESENSORS[indx].selectedResolution?.numberOfLooks)) {
        for (const [index, item] of this.AVAILABLESENSORS[
          indx
        ].selectedResolution.numberOfLooks.entries()) {
          if (item === 'x5') {
            this.AVAILABLESENSORS[indx].selectedLooks = item;
            this.AVAILABLESENSORS[indx].numberOfLooks = item;
            looks = item;
          }
        }
      }

      const umbraPrice = isUmbraScan
        ? getUmbraScenePrice(resolution, sceneSize)
        : resolution?.sceneSizePricing[sceneSize][looks];
      row.latency[0].cost = umbraPrice;
      row.latency[0].unitcost = umbraPrice;
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[0].name, indx, row, 1);
    }

    if ((row?.key === OPERATORS.STE && row?.sensor === 'MSI') || (row?.key === OPERATORS.USL && row.name === 'BRO')) {
      this.resetCost(row, resolution, indx);
    }

    this.AVAILABLESENSORS[indx].selectedResolution = resolution;
    this.AVAILABLESENSORS[indx].selectedResolutionValue = resolution.value;

    // GEOSAT: resolution has unitCost; update latency prices + selected cost.
    if (row?.key === OPERATORS.GEOSAT) {
      this.recalculateSelectedCostForRow(indx);
    }

    const selectedLatencyIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
      (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency
    );

    if (selectedLatencyIndex > -1 && this.getModeResolutionPrice(this.AVAILABLESENSORS[indx], resolution) != null) {
      this.calculateUnitcost(indx, selectedLatencyIndex);
    }
    this.syncSensorTooltip(indx, resolution);

    if (row?.key === OPERATORS.AXELSPACE || row?.key === OPERATORS.AT21 || row?.key === OPERATORS.SDS || row?.key === OPERATORS.ORBVIEW) {
      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency,
      );
        if(this.AVAILABLESENSORS[indx]?.key === OPERATORS.ORBVIEW){
            let pricingArray = this.AVAILABLESENSORS[indx].selectedResolution?.pricing;
            if (this.AVAILABLESENSORS[indx].latency) {
              for (const latencyItem of this.AVAILABLESENSORS[indx].latency) {
                const key = this.normalizeOrbviewPricingKey(latencyItem.key);
                if (pricingArray && Object.prototype.hasOwnProperty.call(pricingArray, key)) {
                  const newCost = Number(pricingArray[key]);
                  latencyItem.cost = newCost;
                  latencyItem.unitcost = newCost;
                }
              }
            }
          }

      if (idx > -1) {
        this.calculateUnitcost(indx, idx);
      }
    }

    this.resetValueAddedDropdown(indx, row);
  }

  private recalculateSelectedCostForRow(indx: number): void {
    const row = this.AVAILABLESENSORS?.[indx];
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    if (strategy) {
      strategy.recalculateSelectedCost(row);
      return;
    }

    if (!Array.isArray(row?.latency) || row.latency.length === 0) return;

    let latencyIdx = row.latency.findIndex((elem: any) => elem?.name === row?.selectedLatency);
    if (latencyIdx < 0) {
      latencyIdx = row.latency.findIndex((elem: any) => elem?.selected === true);
    }
    if (latencyIdx < 0) latencyIdx = 0;

    this.calculateUnitcost(indx, latencyIdx);
  }

  isOperatorOnaDisabled(row: any, onaOption: any) {
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    return strategy?.isOnaDisabled?.(onaOption, row) || false;
  }

  resetCost(row, resolution, indx) {
    const selectedIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
      (item) => item.selected === true,
    );

    if (
      (row.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS) &&
      resolution.value.includes('Bundle')
    ) {
      let pricingArray = this.AVAILABLESENSORS[indx].selectedModes[0]?.pricing;
      for (const latencyItem of this.AVAILABLESENSORS[indx].latency) {
        const key = latencyItem.key;
        if (pricingArray.hasOwnProperty(key)) {
          const newCost = Number(pricingArray[key]);
          latencyItem.cost = newCost;
          latencyItem.unitcost = newCost;
        }
      }
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
    } else if (
      row?.key === OPERATORS.STE &&
      row?.sensor === 'MSI' &&
      resolution.value.includes('Pan-sharpened')
    ) {
      let costSTE = this.AVAILABLESENSORS[indx].STElatency[0];
      row.latency[0].cost = costSTE[0].cost;
      row.latency[0].unitcost = costSTE[0].unitcost;
      row.latency[1].cost = costSTE[1].cost;
      row.latency[1].unitcost = costSTE[1].unitcost;
      this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
    }
    else if (row?.key === OPERATORS.USL && row.name === 'BRO') {
          let latency =row.latency;
          
          latency.forEach((item: any) => {
            item.cost = resolution.pricing[item.key];
            item.unitcost = resolution.pricing[item.key];
  
            if(item.selected) {
                this.AVAILABLESENSORS[indx].selectedCost = item.cost;
                this.AVAILABLESENSORS[indx].unitcost = item.unitcost;
              }
          });
        }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    // Convert values to comparable types
    const aValue = typeof a === 'string' ? parseFloat(a) : a;
    const bValue = typeof b === 'string' ? parseFloat(b) : b;

    // Handle cases where one value is NaN (string couldn't be converted to number)
    if (isNaN(aValue) && !isNaN(bValue)) {
      return isAsc ? 1 : -1; // Strings come after numbers
    }
    if (!isNaN(aValue) && isNaN(bValue)) {
      return isAsc ? -1 : 1; // Numbers come before strings
    }

    // Both values are either numbers or strings, compare them
    return (aValue < bValue ? -1 : 1) * (isAsc ? 1 : -1);
  }

  compareArrays(
    array1: any[],
    array2: any[],
    property: string,
    isAsc: boolean,
  ): number | string {
    // Compare the arrays by the specified property
    for (let i = 0; i < Math.min(array1.length, array2.length); i++) {
      const value1 = (array1[i]?.[property] ?? '').toString();
      const value2 = (array2[i]?.[property] ?? '').toString();
      const numericValue1 = value1.match(/\d+(\.\d+)?/g);
      const numericValue2 = value2.match(/\d+(\.\d+)?/g);

      const comparisonResult =
        numericValue1 && numericValue2
          ? parseFloat(numericValue1[0]) - parseFloat(numericValue2[0])
          : value1.localeCompare(value2, undefined, {
              sensitivity: 'base',
              numeric: true,
            });

      if (comparisonResult !== 0) {
        return comparisonResult * (isAsc ? 1 : -1);
      }
    }

    // If all compared elements are equal, compare the lengths of the arrays
    return (array1.length - array2.length) * (isAsc ? 1 : -1);
  }

  private operatorLabel(row: any): string {
    const displayName =
      this.currentUser?.obfuscated && row.obfuscateName
        ? row.obfuscateName
        : row.name;
  const sensor = row.sensor ?? '';
  return `${displayName ?? ''} ${sensor}`.trim();
  }

  private compareStr(a: any, b: any, isAsc: boolean) {
    const A = (a ?? '').toString();
    const B = (b ?? '').toString();
    const res = A.localeCompare(B, undefined, {
      sensitivity: 'base',
      numeric: true,
    });
    return isAsc ? res : -res;
  }

  private hasSameRowSet(a: any[], b: any[]): boolean {
    if (a.length !== b.length) {
      return false;
    }

    const setA = new Set(a);
    return b.every((item) => setA.has(item));
  }

  private getResolutionSortArray(row: any): { value: string }[] {
    const selectedResolution =
      row?.selectedResolutionValue ||
      row?.selectedResolution?.value ||
      row?.resolution?.[0]?.value ||
      row?.rf_services?.[0]?.value;
    const refreshRate = row?.selectedRefreshRate?.value || row?.updateFrequency;

    const values = [selectedResolution, refreshRate]
      .filter((value) => !!value)
      .map((value) => ({ value: this.getResolutionLabel(value) }));

    return values.length ? values : [{ value: '' }];
  }

  sortData(sort: Sort) {
    const data = this.AVAILABLESENSORS.slice();
    if (!sort.active || sort.direction === '') {
      const restoreBaseline =
        this.sensorSortBaseline.length > 0 &&
        this.hasSameRowSet(this.sensorSortBaseline, data);
      this.AVAILABLESENSORS = restoreBaseline
        ? this.sensorSortBaseline.slice()
        : data;
      this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
      this.updateSelectionAfterDataSourceChange();
      return;
    }

    if (sort.direction === 'asc') {
      this.sensorSortBaseline = data.slice();
    }

    this.AVAILABLESENSORS = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'operator':
          const aLabel = this.operatorLabel(a);
          const bLabel = this.operatorLabel(b);
          return this.compareStr(aLabel, bLabel, isAsc);
        case 'resolution':
          return this.compareArrays(
            this.getResolutionSortArray(a),
            this.getResolutionSortArray(b),
            'value',
            isAsc,
          );
        case 'area_calculated':
          return this.compare(a.minarea, b.minarea, isAsc);
        default:
          return 0;
      }
    });
    this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
    this.updateSelectionAfterDataSourceChange();
  }

  extractAndCalculateValues(inputString: string): number {
    // Match decimal or integer numbers
    const numbers = inputString.match(/\d+(\.\d+)?/g);

    if (numbers && numbers.length >= 2) {
      const firstNumber = parseFloat(numbers[0]);
      const secondNumber = parseFloat(numbers[1]);
      return firstNumber * secondNumber;
    }
    if (numbers && numbers.length === 1) {
      return parseFloat(numbers[0]);
    }
    return 0;
  }

  getPlaceHolder(row: any, indx: any) {
    if (row?.key === OPERATORS.WEATHEREX) {
      return row.collection_mode[0]?.name || row.collection_mode[0]?.key || '';
    } else if (
      row.collection_mode[0]?.isCaptureMode &&
      !row.collection_mode[0]?.isProductLevel
    ) {
      return row.collection_mode[0].captureMode;
    } else if (
      row.collection_mode[0]?.isProductLevel &&
      !row.collection_mode[0]?.isCaptureMode
    ) {
      return row.collection_mode[0].productLevel;
    } else
      return `${row.collection_mode[0].captureMode} (${row.collection_mode[0].productLevel})`;
  }

  getTooltip(row: any, indx: any, sensor: any) {
    this.AVAILABLESENSORS[indx].tooltipValue = row?.minTooltip;
    this.AVAILABLESENSORS[indx].minimumArea = row?.value;
  }

  onMouseOut() {
    this.tooltipDisabled = true;
    this.detailsText = '';
  }

  OpenPopup(row: any) {
    let sensorName = row?.displayName + ' ' + row.sensor;
    let resolution: any, name: any;
    if (row?.resolution) {
      if (row?.resolution[0]?.previewvalue) {
        resolution = row?.resolution[0]?.previewvalue;
      } else resolution = row?.resolution[0]?.value;
      name = row?.imageryname;
      if (row?.selectedModes[0]?.imageryname) {
        let selectedModes = row?.selectedModes[0];
        name = selectedModes?.imageryname;
        if (selectedModes?.resolution?.length > 0) {
          resolution = selectedModes.resolution[0];
        }
      }
    }
    let mode: any;
    if (row?.collection_mode) {
      if (row?.collection_mode[0]?.previewmode) {
        mode = row?.collection_mode[0].previewmode;
      } else if (row?.collection_mode[0]?.tooltip) {
        mode = row?.collection_mode[0].tooltip;
      } else mode = row?.collection_mode[0]?.captureMode;
    }
    if (
      row?.selectedModes[0]?.imageryname &&
      row?.selectedModes[0]?.captureMode
    ) {
      mode = row?.selectedModes[0]?.captureMode;
    }
    let height: any, width: any;
    if (row.sensor === 'Video') {
      height = '75%';
      width = '65%';
    } else {
      height = '85%';
      width = '60%';
    }
    this.dialog.open(SensorpreviewComponent, {
          width: width,
          height: height,
          data: {
            sensor: sensorName,
            resolution: resolution,
            imageName: name,
            mode: mode,
            operatorKey: row.key,
            sensorType: row.sensor,
            baseUrl: environment.geoServerUrl,
            sensorId: row?.sensorId
          },
          backdropClass: 'blurred',
          disableClose: true,
        });
  }

  shouldDisableTier(elem: any, row: any) {
    const subDailyRecurrent = this.capellaEnable && row.sensor != 'SAR';
    const subdailyEnable =
      this.satCapeEnable &&
      row.sensor != 'SAR' &&
      row?.key != this.OPERATOR.SATELLOGIC &&
      row?.key != this.OPERATOR.STE &&
      row?.key != this.OPERATOR.USL &&
      row?.key != this.OPERATOR.BLACKSKY &&
      row?.key != OPERATORS.STE_TELEOS;

    return (
      elem.cost == 0.0 ||
      (row.prevent && row?.key != OPERATORS.AT21) ||
      subDailyRecurrent ||
      subdailyEnable
    );
  }

  shouldDisableResolution(item: any, row: any, index: number) {
    const disableAT21 = item.disable && row?.key === OPERATORS.AT21;
    const disableSTE =
      item.disable &&
      (row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS) &&
      row.resolution?.length >= 1 &&
      row?.sensor === 'SAR';
    const umbra = row?.key === OPERATORS.UMBRA && item.disabled;
    const disableSynspective =
      item.disable && row?.key === OPERATORS.SYNSPECTIVE;
    const isi =
      row?.key === OPERATORS.ISI && item.disable && row.resolution?.length > 1;
    const capella =
      row?.key === OPERATORS.CAPELLA &&
      item.disable &&
      row.resolution?.length > 1;
    const head =
      row?.key === OPERATORS.HEAD && item.disable && row.resolution?.length > 1;
    const sensor =
      (row?.key === OPERATORS.GOKTURK ||
        row?.key === OPERATORS.GHG ||
        row?.key === OPERATORS.ECURS ||
        row?.key === OPERATORS.ECURS_L ||
        row?.key === OPERATORS.SATELLOGIC ||
        row?.key === OPERATORS.SATELLITEVU_VANZYL ||
        row?.key === OPERATORS.GEOSAT ||
        row?.key === OPERATORS.ICEYE) &&
      item.disable &&
      row.resolution?.length > 1;

    return (
      row.prevent ||
      disableAT21 ||
      disableSTE ||
      umbra ||
      disableSynspective ||
      isi ||
      capella ||
      head ||
      sensor
    );
  }

  private getSelectedCollectionModeKey(row: any): string | null {
    const selected =
      row?.modeResetValue ?? row?.selectedModes?.[0]?.key ?? row?.selectedMode;

    if (Array.isArray(selected)) {
      return selected[0] ?? null;
    }

    if (selected && typeof selected === 'object') {
      return selected.key ?? null;
    }

    return selected ?? null;
  }


  shouldEnableIndicesOption(indices: any, row: any): boolean {
    if (!indices?.productMode) {
      return true;
    }

    const selectedModeKey = this.getSelectedCollectionModeKey(row);
    return selectedModeKey === indices.productMode;
  }

  getEnabledIndicesArray(row: any): any[] {
    const indicesArray = Array.isArray(row?.indicesArray) ? row.indicesArray : [];
    if (!indicesArray.length || row?.prevent) {
      return [];
    }

    return indicesArray.filter((indices: any) => this.shouldEnableIndicesOption(indices, row));
  }

  private normalizeModeValue(value: any): string {
    return (value ?? '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  isValueAddedDisabled(row: any): boolean {

    const valAddedList = Array.isArray(row?.valAddedArray) ? row.valAddedArray : [];
    if (!valAddedList.length) {
      return false;
    }

    const selectedModeCandidates = [
      row?.selectedMode,
      row?.modeResetValue,
      row?.selectedModes?.[0]?.key,
      row?.selectedModes?.[0]?.captureMode,
      row?.selectedModes?.[0]?.productLevel,
      row?.selectedModes?.[0]?.captureMode && row?.selectedModes?.[0]?.productLevel
        ? `${row.selectedModes[0].captureMode} (${row.selectedModes[0].productLevel})`
        : null,
      this.getSelectedCollectionModeKey(row),
    ]
      .map((c: any) => this.normalizeModeValue(c))
      .filter((c: string) => !!c);

      const hasOnaWithResolution = Array.isArray(row?.onaWithResolution) && row.onaWithResolution.length > 0;

      const selectedResolution = hasOnaWithResolution
        ? row?.selectedResolution?.originalResolution
        : row?.selectedResolutionValue || row?.selectedResolution?.value || row?.selectedResolution?.originalResolution;

      const hasMatch = valAddedList.some((item: any) => {
        const itemMode = this.normalizeModeValue(item?.productMode);

        const resolutionMatch = hasOnaWithResolution
          ? row.onaWithResolution.some(
              (onaItem: any) => onaItem?.ona === row?.selectedONA && onaItem?.forResolution === selectedResolution
            )
          : item?.sensorResolution === selectedResolution;

        const isModeEmpty = !itemMode;

        return (
          (selectedModeCandidates.includes(itemMode) && resolutionMatch) ||
          (isModeEmpty && resolutionMatch)
        );
      });

    return !hasMatch;
  }

  resetSorting() {
    if (this.sort) {
      this.sort.sort({ id: '', start: 'asc', disableClear: false });
    }
  }

  /**
   * "What is a credit?", from the info icon beside Voyage Radar's unit price.
   *
   * Read-only and sells nothing — the purchase happens later, in
   * VoyageCreditPurchaseComponent, once a target exists to attach a wallet to.
   * The row is passed whole and the dialog reads its own fields off it, the
   * same `{ selectedRow }` contract the purchase dialog takes.
   */
  openVoyageCreditInfo(row: any) {
    this.dialog.open(VoyageCreditInfoComponent, {
      width: '620px',
      maxWidth: '94vw',
      backdropClass: 'blurred',
      data: { selectedRow: row },
    });
  }

  /** Same as openVoyageCreditInfo above, for the VesselFinder catalogue. */
  openVesselFinderCreditInfo(row: any) {
    this.dialog.open(VesselFinderCreditInfoComponent, {
      width: '620px',
      maxWidth: '94vw',
      backdropClass: 'blurred',
      data: { selectedRow: row },
    });
  }

  openEula(task: any, operator: any) {
    this.operatorsEula = {
      name: operator.displayName,
      operatorKey: operator?.key,
      resolution: operator?.resolution,
      startDate: task?.openWindow,
      endDate: task?.closeWindow,
      purpose: task?.purposeOption,
      obfuscateName: operator?.obfuscateName,
    };

    const dialogRef = this.dialog.open(AgreeComponent, {
      width: '65%',
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        operator: this.operatorsEula,
        type: 'save',
        user: this.currentUser,
      },
    });
  }

  /**
   * Text for the cancellation tooltip beside a sensor name. The policy itself
   * lives in src/app/services/operators/cancellation-policy.ts, shared with the
   * taskcost screen and My Tasks — this copy silently lacked the Voyage Radar
   * case, whose `cancel_policy` is [] by design, so the icon appeared and the
   * tooltip was empty.
   */
  selections(row: any) {
    this.tooltipDisabled = false;
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    this.detailsText =
      cancellationPolicySentence(row?.key, strategy, row) ??
      formatCancellationPolicyEntries(row?.cancelPolicy);
  }

  getAxelPrice(size, pricing) {
    if (size < 100) {
      return pricing[0].unitPrice;
    } else {
      for (const range of pricing) {
        if (
          size >= range.minArea &&
          (range.maxArea === undefined || size <= range.maxArea)
        ) {
          return range.unitPrice;
        }
      }
    }
    return null;
  }

  convertCostToPoints(
    cost: any,
    includeLabel: boolean = true,
    row: any = {},
  ): string | number {
    cost = parseFloat(cost);

    if (!this.currentUser.pointsEligible) {
      if (this.dem_calculation) {
        cost += parseFloat(row?.demTotalPrice ?? 0);
      }
      if (this.enable_indices_calculation && row?.indices) {
        cost += parseFloat(row?.TotalIndicesPrice ?? 0);
      }
      if (this.enable_sr_calculation && row?.super_resolution) {
        cost += parseFloat(row?.super_resolution[0]?.cost ?? 0);
      }
      return `${this.currencySign} ${this.roundNumber(cost, 2)}`;
    }

    const conversionFactor = this.getConversionFactor();
    let points = Math.round(cost * conversionFactor);

    if (this.dem_calculation) {
      points += parseFloat(row?.demTotalPoint ?? 0);
    }
    if (this.enable_indices_calculation && row?.indices) {
      cost += parseFloat(row?.TotalIndicesPoint ?? 0);
    }
    if (this.enable_sr_calculation && row?.TotalSRPoint) {
      points += parseFloat(row?.TotalSRPoint ?? 0);
    }
    return includeLabel ? `${points} Points` : points;
  }

  private getConversionFactor(): number {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    return parseFloat(parts[1]) / parseFloat(parts[0]);
  }

  roundNumber(value: number, decimals: number): string {
    if (Number.isInteger(value)) {
      return value.toString();
    }
    return value.toFixed(decimals).replace(/\.?0+$/, '');
  }

  async looksChange(look: any, indx: number, row: any) {
    this.AVAILABLESENSORS[indx].numberOfLooks = look;
    if (row.key === OPERATORS.UMBRA) {
      if (isUmbraScanMode(row)) {
        return;
      }

      let sceneSize = this.AVAILABLESENSORS[indx].selectedModes[0].value;
      let looks = this.AVAILABLESENSORS[indx].numberOfLooks
        ? this.AVAILABLESENSORS[indx].numberOfLooks
        : this.AVAILABLESENSORS[indx].selectedResolution.numberOfLooks[0];

      const umbraPrice =
        this.AVAILABLESENSORS[indx].selectedResolution?.sceneSizePricing[
          sceneSize
        ][looks];

      row.latency[0].cost = umbraPrice;
      row.latency[0].unitcost = umbraPrice;
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[0].name, indx, row, 1);
    }
  }
  calculateDemTotal(row: any[], idx: any) {
    if (!row || !row.length) {
      this.AVAILABLESENSORS[idx].demTotalPrice = 0;
      this.AVAILABLESENSORS[idx].demTotalPoint = 0;
      return;
    }

    // Calculate total price and points for the entire row
    const demTotalPrice = row.reduce(
      (total, curr) => total + Number(curr.cost),
      0,
    );
    const demTotalPoint = this.currentUser.pointsEligible
      ? row.reduce((total, curr) => total + Number(curr.point), 0)
      : 0;

    // Push totals into this.AVAILABLESENSORS[idx]
    this.AVAILABLESENSORS[idx].demTotalPrice = demTotalPrice;
    this.AVAILABLESENSORS[idx].demTotalPoint = demTotalPoint;
  }
  formatGroupedDem(val: any[]) {
    if ((val || []).length > 0) {
      const uniqueProviders = new Set<string>(
        val
          .filter((item) => item && typeof item === 'object')
          .map((item) => item.actionProvider),
      );

      let result = Array.from(uniqueProviders).join(', ');
      if (result.length > 10) {
        result = result.slice(0, 10) + '...';
      }

      return result || undefined;
    }
    return;
  }

  formatGroupedDemTooltip = (val: any[]): any => {
    if (val?.length) {
      return val
        .filter((item) => typeof item === 'object' && item !== null)
        .map((item) => {
          return item.valueAddedDataProduct === 'indices'
            ? `${item.actionProvider}`
            : `${item.actionProvider} ${item.providerResolution}`;
        })
        .join(', ');
    }
    return '';
  };

  formatVAR(arr: any[]) {
    if ((arr || []).length === 0) return {};

    const groupedDemOptions = arr.reduce((acc, curr) => {
      // Check if group already exists, if not, initialize it as an empty array
      if (!acc[curr.actionProvider]) {
        acc[curr.actionProvider] = [];
      }
      // Push current item into the corresponding group array
      acc[curr.actionProvider].push(curr);
      return acc;
    }, {});
    return groupedDemOptions;
  }

  formatvalueAddedOption(sensor: any, mode: any, resolution: any) {
    if (sensor.valueAddedOption) {
      const DxM = sensor.valueAddedOption.filter((i) =>
        this.actionProviders.includes(i.actionProvider),
      );
      DxM.sort((a, b) => {
        const actionA = a.actionProvider || '';
        const actionB = b.actionProvider || '';
        return actionA.localeCompare(actionB);
      });

      const options = DxM.filter(
        (i) =>
          i.sensorResolution === resolution.resolution_value ||
          i.sensorResolution === resolution.value,
      );
      return this.toggleValueAddedOptions(options);
    }
    return [];
  }
  updatevalueAddedOption(newValue: any[], row: any, idx: number) {
    const updatedValue = (newValue || []).filter((item, index, arr) => {
      const existingIndex = arr.findIndex(
        (existingItem) =>
          existingItem.actionProvider === item.actionProvider &&
          existingItem.ProviderName === item.ProviderName &&
          existingItem.sensorResolution === item.sensorResolution,
      );
      return existingIndex === index;
    });

    row.valueAddedOption = updatedValue;
    this.calculateDemTotal(row.valueAddedOption, idx);
  }
  selectDxMOption(dem_item: any, row: any, group: any, idx: number): void {
    if (row.key === 'ISI' && row.selectedModes[0].key === 'Pan-sharpened') {
      this.AVAILABLESENSORS[idx].selectedMode = row?.collection_mode[0].key;
      this.AVAILABLESENSORS[idx].selectedModes = [];
      this.AVAILABLESENSORS[idx].modeSelected = [];
      this.AVAILABLESENSORS[idx].modeResetValue = [];

      this.AVAILABLESENSORS[idx].selectedModes.push(row?.collection_mode[0]);
      this.AVAILABLESENSORS[idx].modeSelected.push(row?.collection_mode[0]);
    }
    if (!this.AVAILABLESENSORS[idx].valueAddedOption) {
      this.AVAILABLESENSORS[idx].valueAddedOption = [];
    }

    // Check if the dem_item is already selected
    const isSelected = row.valueAddedOption.some(
      (item) =>
        item.actionProvider === dem_item.actionProvider &&
        item.ProviderName === dem_item.ProviderName &&
        item.sensorResolution === dem_item.sensorResolution &&
        item.providerResolution === dem_item.providerResolution,
    );

    if (isSelected) {
      // If already selected, unselect it by removing from valueAddedOption
      row.valueAddedOption = row.valueAddedOption.filter(
        (item: any) => item !== dem_item,
      );
    } else {
      // If not selected, remove any previously selected item from the same group
      row.valueAddedOption = row.valueAddedOption.filter(
        (item: any) => item.actionProvider !== group.actionProvider,
      );

      // Add the newly selected item
      row.valueAddedOption.push(dem_item);
    }

    // Update the AVAILABLESENSORS with the new selection
    this.AVAILABLESENSORS[idx].valueAddedOption = row.valueAddedOption;

    // Reset VADP and update the valueAddedOption
    this.resetVADP(row.valueAddedOption, idx);
    this.updatevalueAddedOption(row.valueAddedOption, row, idx);
  }

  filterValueAddedData(sensor: any) {
    if (sensor?.valAddedArray) {
      const options = (sensor?.valAddedArray || []).filter(
        (i) =>
          i.sensorResolution === sensor.selectedResolutionValue ||
          i.sensorResolution === sensor.selectedResolution.value ||
          i.sensorResolution === sensor.selectedResolution?.originalResolution,
      );
      return this.toggleValueAddedOptions(options);
    }
    return [];
  }
  toggleValueAddedOptions(data: any) {
    let resultMap: {
      actionProvider: string;
      items: {
        providerName: string;
        actionProvider: string;
        providerResolution: string;
        cost: string;
        point: string;
        deliveryTime: string;
        sensorResolution: string;
      }[];
    }[] = [];
    
    data.forEach((item) => {
      let actionProvider = item.actionProvider;
      item.point = this.convertCostToPoints(item.cost, false);
      
      let existingactionProvider = resultMap.find(
        (entry) => (entry || []).actionProvider === actionProvider,
      );
      if (existingactionProvider) {
        existingactionProvider.items.push(item);
      } else {
        resultMap.push({
          actionProvider: actionProvider,
          items: [item],
        });
      }
    });
    return resultMap;
  }
  resetValueAddedDropdown(indx, row) {
    this.AVAILABLESENSORS[indx].vadp = [];
    if (row.sensor === 'Stereo' || row.sensor === 'Tristereo') {
      this.AVAILABLESENSORS[indx].demTotalPrice = 0;
      this.AVAILABLESENSORS[indx].demTotalPoint = 0;
      this.AVAILABLESENSORS[indx].valueAddedOption = [];
      this.AVAILABLESENSORS[indx].valueAddedOption = [];
      this.AVAILABLESENSORS[indx].valueAddedAction = this.filterValueAddedData(
        this.AVAILABLESENSORS[indx],
      );
    } else if (row.sensor === 'MSI') {
      this.AVAILABLESENSORS[indx].indices = [];
      const options = row.valAddedArray.filter(
        (i: any) =>
          i.sensorResolution == row.selectedResolution.resolution_value ||
          i.sensorResolution == row.selectedResolution.value ||
          i.sensorResolution == row.selectedResolution?.originalResolution,
      );
      this.AVAILABLESENSORS[indx].indicesArray = options;
    }
  }

  // Function to handle collection duration change
  async collectionChange(data: any, idx: number, item: any, row: any) {
    // Update the collection duration of the selected signal
    if (data?.value?.value) {
      // Update the collection duration of the specific signal in the row
      const selectedSignal = row.signal_of_interest.find(
        (signal) => signal.value === item.value,
      );
      if (selectedSignal) {
        selectedSignal.collectionDuration = data.value.value;
      }

      // Update the collection duration in AVAILABLESENSORS array
      const availableSignal = this.AVAILABLESENSORS[idx]?.signalsOfInterest;
      if (availableSignal && availableSignal.length > 0) {
        const signal = availableSignal.find(
          (signal) => signal.value === item.value,
        );
        if (signal) {
          signal.collectionDuration = data.value.value;
        }

        // Update selected signals display text
        const signalsSelected = availableSignal.filter((sensor) => {
          return (
            Array.isArray(sensor.collection_duration) &&
            sensor.collection_duration.length > 0
          );
        });
        this.AVAILABLESENSORS[idx].signalOfInterest = signalsSelected;
        this.AVAILABLESENSORS[idx].selectedSignals = signalsSelected
          .map((signal) => signal.value)
          .join(', ');
      }
    }
  }

  isAudioSelectionDisabled(item: any, row: any): boolean {
    return row?.prevent || (this.isAudioAllocationRestrictedUser() && !item?.audio);
  }

  getAudioTooltip(item: any): string {
    if (this.isAudioAllocationRestrictedUser() && !item?.audio) {
      return 'Your task allocation does not include audio extraction.';
    }

    if (this.currentUser?.allocated) {
      return 'The task (count) includes one or more audio files.';
    }

    return `Cost of audio recording = ${this.convertCostToPoints(item.audioCost)}. The amount will be refunded to your account if no audio is processed.`;
  }

  private isAudioAllocationRestrictedUser(): boolean {
    return !!(this.currentUser?.cpc || this.currentUser?.allocated);
  }

  // Function to handle collection duration change
  async audioChange(
    event: MatCheckboxChange,
    item: any,
    idx: number,
    row: any,
  ) {
    if (this.AVAILABLESENSORS[idx].selectedSignals)
      this.AVAILABLESENSORS[idx].selectedSignals = '';
    // Update the collection duration of the selected signal
    const selectedSignal = row.signal_of_interest.find(
      (signal) => signal.value === item.value,
    );
    if (selectedSignal) {
      selectedSignal.isAudio = event.checked;
      if (event.checked) {
        selectedSignal.collectionDuration = 60;
      } else
        selectedSignal.collectionDuration =
          selectedSignal.collection_duration[0].value;
    }

    const availableSignal = this.AVAILABLESENSORS[idx]?.signalsOfInterest;
    if (availableSignal && availableSignal.length > 0) {
      const signal = availableSignal.find(
        (signal) => signal.value === item.value,
      );
      if (signal) {
        signal.isAudio = event.checked;
        if (event.checked) {
          signal.collectionDuration = 60;
        } else signal.collectionDuration = signal.collection_duration[0].value;
      }

      // Update selected signals display text
      const signalsSelected = availableSignal.filter((sensor) => {
        return (
          Array.isArray(sensor.collection_duration) &&
          sensor.collection_duration.length > 0
        );
      });
      this.AVAILABLESENSORS[idx].signalOfInterest = signalsSelected;
      this.AVAILABLESENSORS[idx].selectedSignals = signalsSelected
        .map((signal) => signal.value)
        .join(', ');
    }
  }

  async signalChange(event: any, idx: number, mySelect?: MatSelect) {
    event.value = event.value.filter((item) => item !== undefined);

    let selectedSignals = event.value;
    this.rfSignals = true;

    // If selected signals array is empty, reset and exit
    if (selectedSignals.length === 0) {
      this.AVAILABLESENSORS[idx].signalOfInterest = [];
      this.AVAILABLESENSORS[idx].signalsOfInterest = [];
      this.rfSignals = false;
      return;
    }

    // Keep the existing `signalOfInterest` values without resetting
    if (
      !this.AVAILABLESENSORS[idx].signalOfInterest ||
      !Array.isArray(this.AVAILABLESENSORS[idx].signalOfInterest)
    ) {
      this.AVAILABLESENSORS[idx].signalOfInterest = [];
      this.AVAILABLESENSORS[idx].signalsOfInterest = [];
    }

    const previousSelectedSignals = [
      ...this.AVAILABLESENSORS[idx].signalsOfInterest,
    ];

    // Check selection validity
    if (this.checkSelection(selectedSignals, idx)) {
      selectedSignals = this.processSignals(
        previousSelectedSignals,
        selectedSignals,
      );
      this.AVAILABLESENSORS[idx].signalsOfInterest = selectedSignals;
    } else {
      // Invalid selection: remove the newly selected item and call signalChange again
      selectedSignals = previousSelectedSignals;
      this.AVAILABLESENSORS[idx].signalsOfInterest = selectedSignals;

      // Set a timeout to refresh UI
      setTimeout(() => {
        if (mySelect) {
          mySelect.value = selectedSignals;
          this.signalChange({ value: selectedSignals }, idx, mySelect);
        }
      }, 0);
      return;
    }

    // Update selected signals for display
    const signalsSelected = this.AVAILABLESENSORS[idx].signalsOfInterest.filter(
      (sensor) => {
        return (
          Array.isArray(sensor.collection_duration) &&
          sensor.collection_duration.length > 0
        );
      },
    );
    this.AVAILABLESENSORS[idx].signalOfInterest = signalsSelected;
    this.AVAILABLESENSORS[idx].selectedSignals = signalsSelected
      .map((signal) => signal.value)
      .join(', ');
  }

  processSignals(previousSignals: any[], newSignals: any[]): any[] {
    return newSignals.map((newSignal) => {
      const matchingPrevSignal = previousSignals.find(
        (prevSignal) => prevSignal.value === newSignal.value,
      );

      // Preserve the collectionDuration from the previous selection if it exists
      if (matchingPrevSignal && matchingPrevSignal.collectionDuration) {
        newSignal.collectionDuration = matchingPrevSignal.collectionDuration;
      } else if (
        newSignal.collection_duration &&
        newSignal.collection_duration.length > 0 &&
        !newSignal.collectionDuration
      ) {
        // If no previous duration exists, use the default
        newSignal.collectionDuration = newSignal.collection_duration[0].value;
      }

      newSignal.checked = true;
      return newSignal;
    });
  }

  checkSelection(selectedItems: any[], index: number): boolean {
    let selectedSignals = selectedItems.filter((sensor) => {
      return (
        Array.isArray(sensor.collection_duration) &&
        sensor.collection_duration.length > 0
      );
    });
    // Define categories
    const gps = ['GPS L1', 'GPS L2', 'GPS L5'];
    const vhf = ['VHF'];
    const uhf = ['UHF'];
    const lBand = ['L-band (ADS-B)', 'L-band (GNSS)', 'L-band (SATCOM)'];
    const sBand = ['S-band'];

    // Separate signals into categories
    const selectedGPS = selectedSignals.filter((s) => gps.includes(s.value));
    const selectedVHF = selectedSignals.filter((s) => vhf.includes(s.value));
    const selectedUHF = selectedSignals.filter((s) => uhf.includes(s.value));
    const selectedLBand = selectedSignals.filter((s) =>
      lBand.includes(s.value),
    );
    const selectedsBand = selectedSignals.filter((s) =>
      sBand.includes(s.value),
    );

    // Rule: Only one GPS signal can be selected at a time
    if (selectedGPS.length > 1) {
      const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      return false;
    }
    if (selectedSignals.length > 1 && selectedsBand.length > 0) {
              const message = `You can request a maximum of three signals when combining UHF, VHF, and
                          L-Band, charged individually, for the same price in a single task. You can
                          request all the other signals individually.`;
              this.popupService.openPopup(WarningPopup, message, '', '50%');
              return false;
        }
    // Check for invalid combinations
    if (selectedGPS.length > 0) {
      if (selectedSignals.length > selectedGPS.length) {
        const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        return false;
      }
    } else {
      // Validate non-GPS selections
      if (selectedVHF.length + selectedUHF.length + selectedLBand.length > 3) {
        const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        return false;
      }
      if (
        selectedVHF.length > 1 ||
        selectedUHF.length > 1 ||
        selectedLBand.length > 1
      ) {
        const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        return false;
      }
    }

    return true;
  }

  onSelectOpened(index: number) {
    if (this.AVAILABLESENSORS[index].signalOfInterest)
      this.initialSelection = [
        ...this.AVAILABLESENSORS[index].signalOfInterest,
      ];
  }

  onSelectClosed(index: number) {
    const currentSelection = this.AVAILABLESENSORS[index].signalOfInterest;

    const isSelectionChanged =
      JSON.stringify(this.initialSelection) !==
      JSON.stringify(currentSelection);

    if (isSelectionChanged) {
      this.AVAILABLESENSORS[index].isAudio = false;
      const isVHFUHF = this.AVAILABLESENSORS[index].signalOfInterest?.some(
        (item) => item.value === 'VHF',
      );

      if (isVHFUHF) {
        const dialogRef = this.dialog.open(ConfirmPopupComponent, {
          width: '50%',
          backdropClass: 'blurred',
          disableClose: true,
          data: { message: OPERATORS.LBAND },
        });

        dialogRef?.afterClosed().subscribe(async (result) => {
          if (result === 'yes') {
            this.AVAILABLESENSORS[index].collectionDuration = 60;
            this.AVAILABLESENSORS[index].isAudio = true;
          } else {
            this.AVAILABLESENSORS[index].collectionDuration =
              this.AVAILABLESENSORS[index].collection_duration[0].value;
            this.AVAILABLESENSORS[index].isAudio = false;
          }
        });
      }
    }
  }

  costToPoints(cost: number): string {
    if (this.currentUser.pointsEligible) {
      const [part1, part2] = this.currentUser.sensorConversionFactor
        .split(':')
        .map(parseFloat);
      const conversionFactor = part2 / part1;
      const points = Math.round(cost * conversionFactor);
      return `${points} Points`;
    } else {
      return formatCurrency(cost);
    }
  }

  hasElevationModelOption(row: any): boolean {
    return !!row?.valAddedArray?.find(
      (item: any) => item?.valueAddedDataProduct === 'elevationModel',
    );
  }

  onDxMCheckboxChange(row: any, idx: number, type: any): void {
    if (!row.isDxMSelected) {
      if (!this.AVAILABLESENSORS[idx].vadp)
        this.AVAILABLESENSORS[idx].vadp = [];
      this.AVAILABLESENSORS[idx].vadp.push(type);
      this.AVAILABLESENSORS[idx].isDxMSelected = true;
    } else {
      this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(
        (item: any) => item !== type,
      );
      this.AVAILABLESENSORS[idx].isDxMSelected = false;
    }
  }

  onSRCheckboxChange(row: any, idx: number, type: any): void {
    if (!row.isSRSelected) {
      if (!this.AVAILABLESENSORS[idx].vadp)
        this.AVAILABLESENSORS[idx].vadp = [];
      this.AVAILABLESENSORS[idx].vadp.push(type);
      this.AVAILABLESENSORS[idx].isSRSelected = true;
    } else {
      this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(
        (item: any) => item !== type,
      );
      this.AVAILABLESENSORS[idx].isSRSelected = false;
    }
  }
  resetVADP(row, idx) {
    // Remove items with actionProvider in the specified list
    this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(
      (item: any) => !this.actionProviders.includes(item.actionProvider),
    );

    row.forEach((i) => {
      this.AVAILABLESENSORS[idx].vadp.push(i);
    });
  }
  // Get selected values for a specific row
  getSelectedVadp(row: any): any[] {
    if (!row.vadp) {
      return [];
    }

    // Initialize arrays for special and regular values
    const specialValue = 'SR';
    const vadpValue = 'DxM';
    const indicesValue = 'Indices';
    const filteredVadp = row.vadp.filter((item) => item === specialValue);
    const regularItems = row.vadp.filter(
      (item) =>
        item !== specialValue &&
        (item || {}).actionProvider === 'Super Resolution',
    );
    const DxMItems = row.vadp.filter((item) =>
      this.actionProviders.includes((item || {}).actionProvider),
    );
    const IndicesItems = row.vadp.filter(
      (item) => item.valueAddedDataProduct === 'indices',
    );

    // Combine special value and regular items
    const updatedVadp = [
      specialValue,
      ...regularItems,
      vadpValue,
      ...DxMItems,
      indicesValue,
      ...IndicesItems,
    ];

    return updatedVadp;
  }
  
  setIndices(sensor: any, selectedResolution?: any) {
    let options = [];
    if (sensor.valueAddedOption) {
      options = sensor.valueAddedOption.filter(
        (i) => i.valueAddedDataProduct === 'indices',
      );
      if (selectedResolution && sensor.sensortype === 'MSI') {
        options = options.filter(
          (i: any) =>
            i.sensorResolution === selectedResolution?.resolution_value ||
            i.sensorResolution === selectedResolution?.value ||
            i.sensorResolution === selectedResolution?.originalResolution,
        );
      }
      options.forEach((item: any) => {
        item.point = this.convertCostToPoints(item.cost, false);
      });
    }
    return options;
  }

  onIndicesCheckboxChange(row: any, idx: number, type: any): void {
    if (!row.isIndicesSelected) {
      if (!this.AVAILABLESENSORS[idx].vadp)
        this.AVAILABLESENSORS[idx].vadp = [];
      this.AVAILABLESENSORS[idx].vadp.push(type);
      this.AVAILABLESENSORS[idx].isIndicesSelected = true;
    } else {
      this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(
        (item: any) => item !== type,
      );
      this.AVAILABLESENSORS[idx].isIndicesSelected = false;
    }
  }
  selectIndicesOption(obj: any, row: any, idx: number): void {
    if (
      !row?.isIndicesSelected ||
      row?.prevent ||
      !this.shouldEnableIndicesOption(obj, row)
    ) {
      return;
    }

    if (!row.indices) {
      row.indices = [];
    }

    // Check if the actionProvider is already selected
    const isSelected = row.indices.some((item) => item === obj);

    if (isSelected) {
      // If the resolution is already selected, unselect it by removing it from indices
      row.indices = row.indices.filter((item) => item !== obj);
      obj.isIndices = false;

      // Remove it from AVAILABLESENSORS[idx].vadp as well
      this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(
        (item) => item !== obj,
      );
    } else {
      // If the resolution is not selected, clear any previous selections and select the new one
      if (row?.sensor !== 'HSI' && row?.key !== OPERATORS.AXELSPACE)
        row.indices = [];
      row.indices.push(obj);
      obj.isIndices = true;
      // Remove all items with isIndices === true from AVAILABLESENSORS[idx].vadp
      //  if(row?.sensor !== 'HSI' && row?.key !== OPERATORS.AXELSPACE) {
      //   this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(
      //     (item) => !item.isIndices
      //   );
      // }
      this.AVAILABLESENSORS[idx].vadp.push(obj);
    }
    this.calculateIndicesTotal(row.indices, idx);
  }
  calculateIndicesTotal(row: any[], idx: any) {
    if (!row || !row.length) {
      this.AVAILABLESENSORS[idx].TotalIndicesPrice = 0;
      this.AVAILABLESENSORS[idx].TotalIndicesPoint = 0;
      return;
    }

    // Calculate total price and points for the entire row
    const TotalIndicesPrice = row.reduce(
      (total, curr) => total + Number(curr.cost),
      0,
    );
    const TotalIndicesPoint = this.currentUser.pointsEligible
      ? row.reduce((total, curr) => total + Number(curr.point), 0)
      : 0;

    // Push totals into this.AVAILABLESENSORS[idx]
    this.AVAILABLESENSORS[idx].TotalIndicesPrice = TotalIndicesPrice;
    this.AVAILABLESENSORS[idx].TotalIndicesPoint = TotalIndicesPoint;
  }
  displayVadpSelectTooltip(row: any) {
    if (this.isValueAddedDisabled(row)) {
      return 'The value-added data products (VADPs) are available only at certain imagery product levels or resolutions. Please select the supported imagery product level(s) or resolutions to enable the VADPs.';
    }
    if (
      (row?.valueAddedOption && row?.valueAddedOption.length > 0) ||
      row?.valueAddedAction.length > 0
    ) {
      return '';
    }
    if (
      (row.sensor === 'Stereo' || row.sensor === 'Tristereo') &&
      (row.key == OPERATORS.AT21 ||
        (row.key == OPERATORS.KOMPSAT && row.name != 'KOMPSAT-5'))
    ) {
      if (
        row?.selectedResolution?.value == 'Bundle:0.5m PAN/2m MS' &&
        row?.valueAddedAction.length == 0
      )
        return '';
      return 'Please select either panchromatic or bundle data products for value-added products.';
    }

    if (
      row.sensor === 'MSI' &&
      row?.indicesArray?.length === 0 &&
      (row.key === OPERATORS.AXELSPACE ||
        row.key === OPERATORS.AT21 ||
        row.key === OPERATORS.STE ||
        row.name === 'KOMPSAT-3' ||
        row?.key === OPERATORS.STE_TELEOS)
    ) {
      return 'Indices products require multi-spectral data. Please choose the relevant resolution product meeting the requirement.';
    } else return '';
  }

  closeSelectDropdown(select: MatSelect) {
    select.close();
  }

  isOperatorWithSensor(row: any): boolean {
    const validOperators = [
      OPERATORS.CAPELLA,
      OPERATORS.UMBRA,
      OPERATORS.KOMPSAT,
      OPERATORS.STE,
      OPERATORS.ECURS,
      OPERATORS.STE_TELEOS,
      OPERATORS.ECURS_L,
      OPERATORS.ICEYE,
    ];
    return (
      validOperators.includes(row.key) &&
      (row.sensor === 'SAR' || row.sensor === 'InSAR' || row.sensor === 'ScanSAR')
    );
  }

  getTooltipText(row: any) {
    const selectedMode = row?.selectedModes?.[0];
    if (selectedMode?.defaultPolarization)
      return (
        'Default polarisation is ' + selectedMode.defaultPolarization
      );
    else {
      switch (row.key) {
        case OPERATORS.CAPELLA:
          return (
            'Look Angle' +
            '\n' +
            'Default polarisation is ' +
            polarization[row.key]
          );
        case OPERATORS.UMBRA:
          return (
            'Grazing Angle' +
            '\n' +
            'Default polarisation is ' +
            polarization[row.key]
          );
        default:
          return 'Default polarisation is ' + polarization[row.key];
      }
    }
  }

  selectSROption(resolution: any, row: any, idx: number): void {
    if (!row.super_resolution) {
      row.super_resolution = [];
    }

    // Check if the resolution is already selected
    const isSelected = row.super_resolution.some((item) => item === resolution);

    if (isSelected) {
      // If the resolution is already selected, unselect it by removing it from super_resolution
      row.super_resolution = row.super_resolution.filter(
        (item) => item !== resolution,
      );
      resolution.isSR = false;

      // Remove it from AVAILABLESENSORS[idx].vadp as well
      this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(
        (item) => item !== resolution,
      );
    } else {
      // If the resolution is not selected, clear any previous selections and select the new one
      row.super_resolution = [];
      row.super_resolution.push(resolution);
      resolution.isSR = true;

      // Remove all items with isSR === true from AVAILABLESENSORS[idx].vadp
      this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(
        (item) => !item.isSR,
      );
      this.AVAILABLESENSORS[idx].vadp.push(resolution);
    }
    this.calculateSRTotal(row.super_resolution, idx);
  }
  calculateSRTotal(row: any[], idx: any) {
    if (!row || !row.length) {
      this.AVAILABLESENSORS[idx].TotalSRPrice = 0;
      this.AVAILABLESENSORS[idx].TotalSRPoint = 0;
      return;
    }

    // Calculate total price and points for the entire row
    const TotalSRPrice = row.reduce(
      (total, curr) => total + Number(curr.cost),
      0,
    );
    const TotalSRPoint = this.currentUser.pointsEligible
      ? row.reduce((total, curr) => total + Number(curr.point), 0)
      : 0;

    // Push totals into this.AVAILABLESENSORS[idx]
    this.AVAILABLESENSORS[idx].TotalSRPrice = TotalSRPrice;
    this.AVAILABLESENSORS[idx].TotalSRPoint = TotalSRPoint;
  }
  setSuperResolutions(sensor) {
    let options: any = [];
    if (sensor.valueAddedOption) {
      options = sensor.valueAddedOption.filter(
        (i) => i.actionProvider === 'Super Resolution',
      );
      options.forEach((item) => {
        item.point = this.convertCostToPoints(item.cost, false);
      });
    }
    return options;
  }

    private getModeResolutionPrice(row: any, resolution?: any): number | null {
    if (row?.key !== OPERATORS.ORBVIEW) {
      return null;
    }

    const pricing = row?.selectedModes?.[0]?.pricing;
    if (!pricing || Array.isArray(pricing)) {
      return null;
    }

      const resolutionKey = this.normalizeOrbviewPricingKey(resolution?.value);
      if (
        resolutionKey &&
        Object.prototype.hasOwnProperty.call(pricing, resolutionKey)
      ) {
        const price = Number(pricing[resolutionKey]);
        if (!Number.isNaN(price)) {
          return price;
        }
    }

    return null;
  }

  private normalizeOrbviewPricingKey(value: any): string {
    return (value ?? '').toString().replace(/\./g, '_');
  }

  calculateUnitcost(indx, latencyIndx) {
    const row = this.AVAILABLESENSORS?.[indx];
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    if (strategy) {
      strategy.calculateUnitCost({ sensorRow: row, latencyIndx });
      return;
    }

    if (this.AVAILABLESENSORS[indx].ONAFactor == undefined)
      this.AVAILABLESENSORS[indx].ONAFactor = 1;
    if (this.AVAILABLESENSORS[indx].holdbackFactor == undefined)
      this.AVAILABLESENSORS[indx].holdbackFactor = 1;
    if (this.AVAILABLESENSORS[indx].cloudFactor == undefined)
      this.AVAILABLESENSORS[indx].cloudFactor = 1;

    const holdbackFactor = this.AVAILABLESENSORS[indx].holdbackFactor - 1;
    const cloudFactor = this.AVAILABLESENSORS[indx].cloudFactor - 1;
    const ONAFactor = this.AVAILABLESENSORS[indx].ONAFactor - 1;
    const resolutionFactor =
      this.AVAILABLESENSORS[indx].selectedResolution?.multiplier ?? 1;
    const modeResolutionPrice = this.getModeResolutionPrice(
      this.AVAILABLESENSORS[indx],
      this.AVAILABLESENSORS[indx].selectedResolution
    );  

    const baseUnitCost = modeResolutionPrice ?? this.AVAILABLESENSORS[indx].latency[latencyIndx].unitcost;
    const baseCost = baseUnitCost * resolutionFactor;
    const holdbackValue = baseCost * holdbackFactor;
    const ccValue = baseCost * cloudFactor;
    const onaValue = baseCost * ONAFactor;

    this.AVAILABLESENSORS[indx].selectedCost =
      +baseCost + +holdbackValue + +ccValue + +onaValue;
    this.AVAILABLESENSORS[indx].unitcost =
      this.AVAILABLESENSORS[indx].selectedCost;

    if (this.AVAILABLESENSORS[indx].key == OPERATORS.SATELLOGIC) {
      this.AVAILABLESENSORS[indx].minarea = this.extractAndCalculateValues(
        this.AVAILABLESENSORS[indx].minimumArea,
      );
    }

    if (
      this.AVAILABLESENSORS[indx].userCost > 0 &&
      this.AVAILABLESENSORS[indx].selectedCost > 0
    ) {
      this.AVAILABLESENSORS[indx].selectedCost =
        this.AVAILABLESENSORS[indx].selectedCost *
        this.AVAILABLESENSORS[indx].userCost;
    }
  }

  getProductTooltip(row: any) {
    if (row.selectedModes && row.selectedModes[0]) {
      const captureMode = row.selectedModes[0].captureMode;
      const productLevel = row.selectedModes[0].productLevel;
      const isProductLevel = row.selectedModes[0].isProductLevel;
      const isCaptureMode = row.selectedModes[0].isCaptureMode;

      const tooltipText =
        isProductLevel && isCaptureMode
          ? `${captureMode} (${productLevel})`
          : isProductLevel && !isCaptureMode
          ? `${productLevel}`
          : captureMode;

      // Show tooltip only if the text length is greater than 10
      return tooltipText;
    }
  }
  setSignalOfInterest(signalOfInterest) {
    if (this.currentUser.pointsEligible) {
      signalOfInterest = signalOfInterest?.map((signal: any) => ({
        ...signal,
        point: this.convertCostToPoints(signal.cost, false),
        ...(signal.audioCost && {
          audioPoint: this.convertCostToPoints(signal.audioCost, false),
        }),
      }));
    }
    return signalOfInterest;
  }

  goNext(mySelect: MatSelect, event: Event, i, row): void {
    this.restoreMatSelectClose();
    event.stopPropagation(); // Prevent propagation
    mySelect.close(); // Close the dropdown
  }

  close(mySelect: MatSelect, event: Event): void {
    this.restoreMatSelectClose();
    event.stopPropagation(); // Prevent propagation
    mySelect.close(); // Close the dropdown
  }

  onOpenedChange(isOpen: boolean) {
    if (isOpen) {
      this.preventMatSelectClose();
    }
  }

  // Override the close behavior of MatSelect to prevent closing
  private preventMatSelectClose() {
    if (this.mySelects && !this.originalClose) {
      // Save the original close method
      this.originalClose = this.mySelects.close;

      // Override the close method
      this.mySelects.close = () => {};
    }
  }

  // Restore the original close behavior
  private restoreMatSelectClose() {
    if (this.mySelects && this.originalClose) {
      this.mySelects.close = this.originalClose;
      this.originalClose = null;
    }
  }

  shouldDisableModes(row) {
    let capella =
      (row.prevent && row?.key != OPERATORS.CAPELLA) ||
      (this.capellaEnable && row.sensor != 'SAR');

    return capella;
  }

  getBandInfo(row: any) {
    this.openMenu();
    let bandInfo = [];
    if (row.key === OPERATORS.WYVERN) {
      const key = `${row.key}_${row.numberOfBands}`;
      bandInfo = SENSOR_BAND_DATA[key] || [];
     } else if ((row.key === OPERATORS.ESPER) || row.key === OPERATORS.PIXXEL || row.sensorBands) bandInfo = row.sensorBands;
    else bandInfo = SENSOR_BAND_DATA[row.key] || [];
    this.bandInfoTooltip = bandInfo;
    this.selectedOperator = row.key;
  }

  openMenu() {
    // Add a custom class to the menu panel when it opens
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      overlayContainer.classList.add('custom-menu-overlay');
    }
  }

  onMenuClosed(): void {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      overlayContainer.classList.remove('custom-menu-overlay');
    }
  }

  selectBandOption(band: any, indx: number, row: any) {
    if (band) {
      this.AVAILABLESENSORS[indx].numberOfBands = band.no_of_bands;
      if (band.tooltip)
        this.AVAILABLESENSORS[indx].sensorTooltip = band.tooltip;

      if (row.key === OPERATORS.ESPER) {
        this.bandPriceUpdate(row, indx, row.numberOfBands);
      }
    }
  }

  bandPriceUpdate(row, i, band) {
    let priceArray = row?.pricing;
    let bands = band;

    if (priceArray) {
      for (const latencyItem of row.latency) {
        const key = latencyItem.key;
        latencyItem.cost = priceArray[key][bands];
        latencyItem.unitcost = priceArray[key][bands];
        this.AVAILABLESENSORS[i].latency = row.latency;
        const selectedIndex = this.AVAILABLESENSORS[i].latency.findIndex(
          (item) => item.selected === true,
        );
        this.taskingOption(row.latency[selectedIndex].name, i, row, 1);
      }
    }
  }

  onClose() {
    this.dialogRef?.close();
  }

  onSelectionChange(event: any, row: any, idx: any): void {
    this.calculateSRTotal(row.super_resolution, idx);
  }

  OpenAdvance(row: any, index: any) {
    const dialog = this.dialog.open(AdvanceSettingsComponent, {
      minWidth: '50%',
      backdropClass: 'blurred',
      disableClose: true,
      data: { selectedRow: row, type: 'advance', openFrom: 'preview' },
    });
  }
  onDropdownChange(event: any) {
    this.taskTierPref = event.value;
    this.initializeData(true);
  }

  getResolutionLabel(value: string): string {
    if (!value) return '';
    const match = value.match(/:(\S+)/); // get text after ":" up to next whitespace
    return match ? match[1] : value;
  }

  checkSupportedTarget(sensor) {
    if (sensor.aoi && sensor.poi) return 'POI & AOI';
    else if (sensor.aoi) return 'AOI';
    else if (sensor.poi) return 'POI';
    else if (sensor.multi_poi) {
      return 'Multi-POI';
    } else return null;
  }

  OpenSatTracking(sensor) {
    this.dialog.open(PreviescreenComponent, {
      width: '50%',
      data: {
        sensor: sensor,
        type: 'satelliteTracking',
        action: 'realTimeData',
        user: this.currentUser,
      },
      backdropClass: 'blurred',
      disableClose: true,
    }); 
    }
    private sortedWeatherExCollectionMode(sensor: any): any[] {
      const cm: any[] = sensor?.collection_mode ?? [];
      if (sensor?.key !== OPERATORS.WEATHEREX) return cm;
      const order = this.apiService.weatherVariables.map((v: any) => v.key);
      return [...cm].sort((a, b) => {
        const ai = order.indexOf(a.key);
        const bi = order.indexOf(b.key);
        return (ai === -1 ? Infinity : ai) - (bi === -1 ? Infinity : bi);
      });
    }

    getCustomTooltip(collectionMode: any) {
    collectionMode?.forEach((eachMode) => {
        const sceneText = `\nThe maximum length is ${eachMode.scene_width}`;
        if (eachMode.mode === this.stripMode) {
          if (!eachMode.minTooltip?.includes(sceneText)) {
            eachMode.minTooltip = `${eachMode.minTooltip ? eachMode.minTooltip + '. ' : ''}${sceneText}km`;
          }
        }
      });
    }

    hasFeature(featureKey: string): boolean {
    return (
      this.currentUser?.planDetails?.features?.some(
        (feature) => feature.key.toLowerCase() === featureKey.toLowerCase(),
      ) || false
    );
  }

  getFeedsData(row) {
    this.openMenu();
    this.feedInfoTooltip = row;
  }
    
  isBandIconPresent(row: any): boolean {
    let marginvalue =
      row.sensortype === 'HSI' || row?.key === OPERATORS.STE_TELEOS;
    if (marginvalue) {
      this.marginValueExist = true;
    }
    if (
      this.marginValueExist &&
      (row.sensortype === 'HSI' || row?.key === OPERATORS.STE_TELEOS)
    )
      return true;
    else if (!!document.querySelector('.bandIcon')) return false;
    else return true;
  }

  private isSensorTypeSelectable(type: any): boolean {
    return !(this.currentUser?.pointsEligible && type?.value === 'AIS');
  }

  private getSelectableSensorTypes(): any[] {
    return (this.SensorsTypes || []).filter((type) =>
      this.isSensorTypeSelectable(type),
    );
  }

  private syncAllSensorTypesCheckbox(): void {
    const selectableTypes = this.getSelectableSensorTypes();
    this.isAllSensorTypesChecked =
      selectableTypes.length > 0 &&
      selectableTypes.every((type) => !!type.selected);
  }

  private hasSelectedSensorTypes(): boolean {
    return (this.SensorsTypes || []).some((type) => !!type.selected);
  }

  private autoSelectAllSensorTypesWhenToggleEnabled(): void {
    if (this.hasSelectedSensorTypes()) {
      return;
    }

    const selectableTypes = this.getSelectableSensorTypes();
    selectableTypes.forEach((type) => {
      type.selected = true;
    });
    this.selectedSARBandType = 'All';
    this.selectedInSARBandType = 'All';
    this.syncAllSensorTypesCheckbox();
  }


  // Sensor selection methods for sub-accounts
  private ensureSelectColumn(): void {
    if (this.enableSelection && !this.displayedColumns.includes('select')) {
      this.displayedColumns.unshift('select');
    }
  }

  private getSelectedTypeValues(): string[] {
    return this.SensorsTypes?.filter(type => type.selected).map(type => type.value) || [];
  }

  private applyPreselection(): void {
    if (!this.enableSelection || !this.preSelectedSensorIds?.length) return;
    if (this.hasAppliedPreselection) return;

    // Preselection is a programmatic operation (edit-mode initialization).
    // Do NOT emit `sensorsSelected` here; emitting would mark parent forms dirty.
    this.suppressSelectionEmit = true;
    try {
      this.selection.clear();
      const dataToCheck = this.dataSource?.data || this.AVAILABLESENSORS;
      if (!dataToCheck || dataToCheck.length === 0) {
        return;
      }

      this.hasAppliedPreselection = true;
      const selectedTypeValues = this.getSelectedTypeValues();

      dataToCheck.forEach((sensor) => {
        if (this.preSelectedSensorIds.includes(sensor.sensorId) && 
            selectedTypeValues.includes(sensor.sensortype)) {
          this.selection.select(sensor);
        }
      });
    } finally {
      this.suppressSelectionEmit = false;
    }
  }

  private updateSelectionAfterDataSourceChange(): void {
    if (!this.enableSelection || !this.dataSource?.data) return;

    // Preserve selection state by re-selecting items that are still in the data
    // AND whose sensor type is currently selected
    const currentlySelected = this.selection.selected;
    const selectedTypeValues = this.getSelectedTypeValues();
    
    this.selection.clear();

    this.dataSource.data.forEach((sensor) => {
      const wasSelected = currentlySelected.find((s) => s.sensorId === sensor.sensorId);
      if (wasSelected && selectedTypeValues.includes(sensor.sensortype)) {
        this.selection.select(sensor);
      }
    });
    
    // Apply preselection only once (edit-mode init). Avoid re-applying after user actions.
    if (!this.hasAppliedPreselection && this.selection.selected.length === 0 && this.preSelectedSensorIds?.length > 0) {
      this.applyPreselection();
    }
  }

  private clearSelectionForSensorType(sensorType: string): void {
    if (!this.enableSelection || !sensorType) return;

    const selectedRows = this.selection.selected || [];
    selectedRows
      .filter((row) => row?.sensortype === sensorType)
      .forEach((row) => this.selection.deselect(row));
  }

  toggleRow(row: any): void {
    this.selection.toggle(row);
    this.emitSensorSelection();
  }

  toggleAllRows(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      if (this.dataSource?.data) {
        this.dataSource.data.forEach((row) => this.selection.select(row));
      }
    }
    this.emitSensorSelection();
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource?.data?.length || 0;
    return numSelected === numRows && numRows > 0;
  }

  emitSensorSelection(): void {
    if (!this.enableSelection) return;
    if (this.suppressSelectionEmit) return;

    const selectedSensors = this.selection.selected.map((sensor) => ({
      id: sensor.sensorId,
      sensorType: sensor.sensor,
      sensorName: sensor.name,
    }));

    this.sensorsSelected.emit(selectedSensors);
  }
}
